import { jsxs as m, jsx as r, Fragment as re } from "react/jsx-runtime";
import at, { forwardRef as Ae, useId as it, useRef as ie, useEffect as me, useState as se, useMemo as Q, useCallback as ae } from "react";
function De(e) {
  var n, t, o = "";
  if (typeof e == "string" || typeof e == "number") o += e;
  else if (typeof e == "object") if (Array.isArray(e)) {
    var i = e.length;
    for (n = 0; n < i; n++) e[n] && (t = De(e[n])) && (o && (o += " "), o += t);
  } else for (t in e) e[t] && (o && (o += " "), o += t);
  return o;
}
function Ve() {
  for (var e, n, t = 0, o = "", i = arguments.length; t < i; t++) (e = arguments[t]) && (n = De(e)) && (o && (o += " "), o += n);
  return o;
}
const Fe = (e) => typeof e == "boolean" ? `${e}` : e === 0 ? "0" : e, Se = Ve, ge = (e, n) => (t) => {
  var o;
  if ((n == null ? void 0 : n.variants) == null) return Se(e, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
  const { variants: i, defaultVariants: s } = n, a = Object.keys(i).map((d) => {
    const p = t == null ? void 0 : t[d], g = s == null ? void 0 : s[d];
    if (p === null) return null;
    const k = Fe(p) || Fe(g);
    return i[d][k];
  }), l = t && Object.entries(t).reduce((d, p) => {
    let [g, k] = p;
    return k === void 0 || (d[g] = k), d;
  }, {}), c = n == null || (o = n.compoundVariants) === null || o === void 0 ? void 0 : o.reduce((d, p) => {
    let { class: g, className: k, ...y } = p;
    return Object.entries(y).every((I) => {
      let [z, w] = I;
      return Array.isArray(w) ? w.includes({
        ...s,
        ...l
      }[z]) : {
        ...s,
        ...l
      }[z] === w;
    }) ? [
      ...d,
      g,
      k
    ] : d;
  }, []);
  return Se(e, a, c, t == null ? void 0 : t.class, t == null ? void 0 : t.className);
}, st = (e, n) => {
  const t = new Array(e.length + n.length);
  for (let o = 0; o < e.length; o++)
    t[o] = e[o];
  for (let o = 0; o < n.length; o++)
    t[e.length + o] = n[o];
  return t;
}, lt = (e, n) => ({
  classGroupId: e,
  validator: n
}), $e = (e = /* @__PURE__ */ new Map(), n = null, t) => ({
  nextPart: e,
  validators: n,
  classGroupId: t
}), xe = "-", je = [], ct = "arbitrary..", dt = (e) => {
  const n = ut(e), {
    conflictingClassGroups: t,
    conflictingClassGroupModifiers: o
  } = e;
  return {
    getClassGroupId: (a) => {
      if (a.startsWith("[") && a.endsWith("]"))
        return mt(a);
      const l = a.split(xe), c = l[0] === "" && l.length > 1 ? 1 : 0;
      return _e(l, c, n);
    },
    getConflictingClassGroupIds: (a, l) => {
      if (l) {
        const c = o[a], d = t[a];
        return c ? d ? st(d, c) : c : d || je;
      }
      return t[a] || je;
    }
  };
}, _e = (e, n, t) => {
  if (e.length - n === 0)
    return t.classGroupId;
  const i = e[n], s = t.nextPart.get(i);
  if (s) {
    const d = _e(e, n + 1, s);
    if (d) return d;
  }
  const a = t.validators;
  if (a === null)
    return;
  const l = n === 0 ? e.join(xe) : e.slice(n).join(xe), c = a.length;
  for (let d = 0; d < c; d++) {
    const p = a[d];
    if (p.validator(l))
      return p.classGroupId;
  }
}, mt = (e) => e.slice(1, -1).indexOf(":") === -1 ? void 0 : (() => {
  const n = e.slice(1, -1), t = n.indexOf(":"), o = n.slice(0, t);
  return o ? ct + o : void 0;
})(), ut = (e) => {
  const {
    theme: n,
    classGroups: t
  } = e;
  return ft(t, n);
}, ft = (e, n) => {
  const t = $e();
  for (const o in e) {
    const i = e[o];
    ze(i, t, o, n);
  }
  return t;
}, ze = (e, n, t, o) => {
  const i = e.length;
  for (let s = 0; s < i; s++) {
    const a = e[s];
    ht(a, n, t, o);
  }
}, ht = (e, n, t, o) => {
  if (typeof e == "string") {
    pt(e, n, t);
    return;
  }
  if (typeof e == "function") {
    bt(e, n, t, o);
    return;
  }
  xt(e, n, t, o);
}, pt = (e, n, t) => {
  const o = e === "" ? n : Pe(n, e);
  o.classGroupId = t;
}, bt = (e, n, t, o) => {
  if (gt(e)) {
    ze(e(o), n, t, o);
    return;
  }
  n.validators === null && (n.validators = []), n.validators.push(lt(t, e));
}, xt = (e, n, t, o) => {
  const i = Object.entries(e), s = i.length;
  for (let a = 0; a < s; a++) {
    const [l, c] = i[a];
    ze(c, Pe(n, l), t, o);
  }
}, Pe = (e, n) => {
  let t = e;
  const o = n.split(xe), i = o.length;
  for (let s = 0; s < i; s++) {
    const a = o[s];
    let l = t.nextPart.get(a);
    l || (l = $e(), t.nextPart.set(a, l)), t = l;
  }
  return t;
}, gt = (e) => "isThemeGetter" in e && e.isThemeGetter === !0, vt = (e) => {
  if (e < 1)
    return {
      get: () => {
      },
      set: () => {
      }
    };
  let n = 0, t = /* @__PURE__ */ Object.create(null), o = /* @__PURE__ */ Object.create(null);
  const i = (s, a) => {
    t[s] = a, n++, n > e && (n = 0, o = t, t = /* @__PURE__ */ Object.create(null));
  };
  return {
    get(s) {
      let a = t[s];
      if (a !== void 0)
        return a;
      if ((a = o[s]) !== void 0)
        return i(s, a), a;
    },
    set(s, a) {
      s in t ? t[s] = a : i(s, a);
    }
  };
}, Ne = "!", Re = ":", yt = [], Te = (e, n, t, o, i) => ({
  modifiers: e,
  hasImportantModifier: n,
  baseClassName: t,
  maybePostfixModifierPosition: o,
  isExternal: i
}), wt = (e) => {
  const {
    prefix: n,
    experimentalParseClassName: t
  } = e;
  let o = (i) => {
    const s = [];
    let a = 0, l = 0, c = 0, d;
    const p = i.length;
    for (let z = 0; z < p; z++) {
      const w = i[z];
      if (a === 0 && l === 0) {
        if (w === Re) {
          s.push(i.slice(c, z)), c = z + 1;
          continue;
        }
        if (w === "/") {
          d = z;
          continue;
        }
      }
      w === "[" ? a++ : w === "]" ? a-- : w === "(" ? l++ : w === ")" && l--;
    }
    const g = s.length === 0 ? i : i.slice(c);
    let k = g, y = !1;
    g.endsWith(Ne) ? (k = g.slice(0, -1), y = !0) : (
      /**
       * In Tailwind CSS v3 the important modifier was at the start of the base class name. This is still supported for legacy reasons.
       * @see https://github.com/dcastil/tailwind-merge/issues/513#issuecomment-2614029864
       */
      g.startsWith(Ne) && (k = g.slice(1), y = !0)
    );
    const I = d && d > c ? d - c : void 0;
    return Te(s, y, k, I);
  };
  if (n) {
    const i = n + Re, s = o;
    o = (a) => a.startsWith(i) ? s(a.slice(i.length)) : Te(yt, !1, a, void 0, !0);
  }
  if (t) {
    const i = o;
    o = (s) => t({
      className: s,
      parseClassName: i
    });
  }
  return o;
}, kt = (e) => {
  const n = /* @__PURE__ */ new Map();
  return e.orderSensitiveModifiers.forEach((t, o) => {
    n.set(t, 1e6 + o);
  }), (t) => {
    const o = [];
    let i = [];
    for (let s = 0; s < t.length; s++) {
      const a = t[s], l = a[0] === "[", c = n.has(a);
      l || c ? (i.length > 0 && (i.sort(), o.push(...i), i = []), o.push(a)) : i.push(a);
    }
    return i.length > 0 && (i.sort(), o.push(...i)), o;
  };
}, Nt = (e) => ({
  cache: vt(e.cacheSize),
  parseClassName: wt(e),
  sortModifiers: kt(e),
  ...dt(e)
}), Ct = /\s+/, At = (e, n) => {
  const {
    parseClassName: t,
    getClassGroupId: o,
    getConflictingClassGroupIds: i,
    sortModifiers: s
  } = n, a = [], l = e.trim().split(Ct);
  let c = "";
  for (let d = l.length - 1; d >= 0; d -= 1) {
    const p = l[d], {
      isExternal: g,
      modifiers: k,
      hasImportantModifier: y,
      baseClassName: I,
      maybePostfixModifierPosition: z
    } = t(p);
    if (g) {
      c = p + (c.length > 0 ? " " + c : c);
      continue;
    }
    let w = !!z, F = o(w ? I.substring(0, z) : I);
    if (!F) {
      if (!w) {
        c = p + (c.length > 0 ? " " + c : c);
        continue;
      }
      if (F = o(I), !F) {
        c = p + (c.length > 0 ? " " + c : c);
        continue;
      }
      w = !1;
    }
    const S = k.length === 0 ? "" : k.length === 1 ? k[0] : s(k).join(":"), j = y ? S + Ne : S, G = j + F;
    if (a.indexOf(G) > -1)
      continue;
    a.push(G);
    const H = i(F, w);
    for (let M = 0; M < H.length; ++M) {
      const E = H[M];
      a.push(j + E);
    }
    c = p + (c.length > 0 ? " " + c : c);
  }
  return c;
}, zt = (...e) => {
  let n = 0, t, o, i = "";
  for (; n < e.length; )
    (t = e[n++]) && (o = Oe(t)) && (i && (i += " "), i += o);
  return i;
}, Oe = (e) => {
  if (typeof e == "string")
    return e;
  let n, t = "";
  for (let o = 0; o < e.length; o++)
    e[o] && (n = Oe(e[o])) && (t && (t += " "), t += n);
  return t;
}, Mt = (e, ...n) => {
  let t, o, i, s;
  const a = (c) => {
    const d = n.reduce((p, g) => g(p), e());
    return t = Nt(d), o = t.cache.get, i = t.cache.set, s = l, l(c);
  }, l = (c) => {
    const d = o(c);
    if (d)
      return d;
    const p = At(c, t);
    return i(c, p), p;
  };
  return s = a, (...c) => s(zt(...c));
}, Lt = [], D = (e) => {
  const n = (t) => t[e] || Lt;
  return n.isThemeGetter = !0, n;
}, Ge = /^\[(?:(\w[\w-]*):)?(.+)\]$/i, He = /^\((?:(\w[\w-]*):)?(.+)\)$/i, It = /^\d+(?:\.\d+)?\/\d+(?:\.\d+)?$/, Ft = /^(\d+(\.\d+)?)?(xs|sm|md|lg|xl)$/, St = /\d+(%|px|r?em|[sdl]?v([hwib]|min|max)|pt|pc|in|cm|mm|cap|ch|ex|r?lh|cq(w|h|i|b|min|max))|\b(calc|min|max|clamp)\(.+\)|^0$/, jt = /^(rgba?|hsla?|hwb|(ok)?(lab|lch)|color-mix)\(.+\)$/, Rt = /^(inset_)?-?((\d+)?\.?(\d+)[a-z]+|0)_-?((\d+)?\.?(\d+)[a-z]+|0)/, Tt = /^(url|image|image-set|cross-fade|element|(repeating-)?(linear|radial|conic)-gradient)\(.+\)$/, ee = (e) => It.test(e), v = (e) => !!e && !Number.isNaN(Number(e)), te = (e) => !!e && Number.isInteger(Number(e)), we = (e) => e.endsWith("%") && v(e.slice(0, -1)), U = (e) => Ft.test(e), Xe = () => !0, Bt = (e) => (
  // `colorFunctionRegex` check is necessary because color functions can have percentages in them which which would be incorrectly classified as lengths.
  // For example, `hsl(0 0% 0%)` would be classified as a length without this check.
  // I could also use lookbehind assertion in `lengthUnitRegex` but that isn't supported widely enough.
  St.test(e) && !jt.test(e)
), Me = () => !1, Et = (e) => Rt.test(e), Wt = (e) => Tt.test(e), Dt = (e) => !u(e) && !f(e), Vt = (e) => oe(e, Ke, Me), u = (e) => Ge.test(e), ne = (e) => oe(e, Qe, Bt), Be = (e) => oe(e, Yt, v), $t = (e) => oe(e, Ze, Xe), _t = (e) => oe(e, Je, Me), Ee = (e) => oe(e, Ye, Me), Pt = (e) => oe(e, qe, Wt), pe = (e) => oe(e, Ue, Et), f = (e) => He.test(e), de = (e) => le(e, Qe), Ot = (e) => le(e, Je), We = (e) => le(e, Ye), Gt = (e) => le(e, Ke), Ht = (e) => le(e, qe), be = (e) => le(e, Ue, !0), Xt = (e) => le(e, Ze, !0), oe = (e, n, t) => {
  const o = Ge.exec(e);
  return o ? o[1] ? n(o[1]) : t(o[2]) : !1;
}, le = (e, n, t = !1) => {
  const o = He.exec(e);
  return o ? o[1] ? n(o[1]) : t : !1;
}, Ye = (e) => e === "position" || e === "percentage", qe = (e) => e === "image" || e === "url", Ke = (e) => e === "length" || e === "size" || e === "bg-size", Qe = (e) => e === "length", Yt = (e) => e === "number", Je = (e) => e === "family-name", Ze = (e) => e === "number" || e === "weight", Ue = (e) => e === "shadow", qt = () => {
  const e = D("color"), n = D("font"), t = D("text"), o = D("font-weight"), i = D("tracking"), s = D("leading"), a = D("breakpoint"), l = D("container"), c = D("spacing"), d = D("radius"), p = D("shadow"), g = D("inset-shadow"), k = D("text-shadow"), y = D("drop-shadow"), I = D("blur"), z = D("perspective"), w = D("aspect"), F = D("ease"), S = D("animate"), j = () => ["auto", "avoid", "all", "avoid-page", "page", "left", "right", "column"], G = () => [
    "center",
    "top",
    "bottom",
    "left",
    "right",
    "top-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-top",
    "top-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-top",
    "bottom-right",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "right-bottom",
    "bottom-left",
    // Deprecated since Tailwind CSS v4.1.0, see https://github.com/tailwindlabs/tailwindcss/pull/17378
    "left-bottom"
  ], H = () => [...G(), f, u], M = () => ["auto", "hidden", "clip", "visible", "scroll"], E = () => ["auto", "contain", "none"], h = () => [f, u, c], R = () => [ee, "full", "auto", ...h()], A = () => [te, "none", "subgrid", f, u], V = () => ["auto", {
    span: ["full", te, f, u]
  }, te, f, u], $ = () => [te, "auto", f, u], J = () => ["auto", "min", "max", "fr", f, u], P = () => ["start", "end", "center", "between", "around", "evenly", "stretch", "baseline", "center-safe", "end-safe"], N = () => ["start", "end", "center", "stretch", "center-safe", "end-safe"], B = () => ["auto", ...h()], Y = () => [ee, "auto", "full", "dvw", "dvh", "lvw", "lvh", "svw", "svh", "min", "max", "fit", ...h()], x = () => [ee, "screen", "full", "dvw", "lvw", "svw", "min", "max", "fit", ...h()], W = () => [ee, "screen", "full", "lh", "dvh", "lvh", "svh", "min", "max", "fit", ...h()], b = () => [e, f, u], ce = () => [...G(), We, Ee, {
    position: [f, u]
  }], C = () => ["no-repeat", {
    repeat: ["", "x", "y", "space", "round"]
  }], X = () => ["auto", "cover", "contain", Gt, Vt, {
    size: [f, u]
  }], Z = () => [we, de, ne], T = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    "full",
    d,
    f,
    u
  ], _ = () => ["", v, de, ne], K = () => ["solid", "dashed", "dotted", "double"], q = () => ["normal", "multiply", "screen", "overlay", "darken", "lighten", "color-dodge", "color-burn", "hard-light", "soft-light", "difference", "exclusion", "hue", "saturation", "color", "luminosity"], L = () => [v, we, We, Ee], Ie = () => [
    // Deprecated since Tailwind CSS v4.0.0
    "",
    "none",
    I,
    f,
    u
  ], ue = () => ["none", v, f, u], fe = () => ["none", v, f, u], ye = () => [v, f, u], he = () => [ee, "full", ...h()];
  return {
    cacheSize: 500,
    theme: {
      animate: ["spin", "ping", "pulse", "bounce"],
      aspect: ["video"],
      blur: [U],
      breakpoint: [U],
      color: [Xe],
      container: [U],
      "drop-shadow": [U],
      ease: ["in", "out", "in-out"],
      font: [Dt],
      "font-weight": ["thin", "extralight", "light", "normal", "medium", "semibold", "bold", "extrabold", "black"],
      "inset-shadow": [U],
      leading: ["none", "tight", "snug", "normal", "relaxed", "loose"],
      perspective: ["dramatic", "near", "normal", "midrange", "distant", "none"],
      radius: [U],
      shadow: [U],
      spacing: ["px", v],
      text: [U],
      "text-shadow": [U],
      tracking: ["tighter", "tight", "normal", "wide", "wider", "widest"]
    },
    classGroups: {
      // --------------
      // --- Layout ---
      // --------------
      /**
       * Aspect Ratio
       * @see https://tailwindcss.com/docs/aspect-ratio
       */
      aspect: [{
        aspect: ["auto", "square", ee, u, f, w]
      }],
      /**
       * Container
       * @see https://tailwindcss.com/docs/container
       * @deprecated since Tailwind CSS v4.0.0
       */
      container: ["container"],
      /**
       * Columns
       * @see https://tailwindcss.com/docs/columns
       */
      columns: [{
        columns: [v, u, f, l]
      }],
      /**
       * Break After
       * @see https://tailwindcss.com/docs/break-after
       */
      "break-after": [{
        "break-after": j()
      }],
      /**
       * Break Before
       * @see https://tailwindcss.com/docs/break-before
       */
      "break-before": [{
        "break-before": j()
      }],
      /**
       * Break Inside
       * @see https://tailwindcss.com/docs/break-inside
       */
      "break-inside": [{
        "break-inside": ["auto", "avoid", "avoid-page", "avoid-column"]
      }],
      /**
       * Box Decoration Break
       * @see https://tailwindcss.com/docs/box-decoration-break
       */
      "box-decoration": [{
        "box-decoration": ["slice", "clone"]
      }],
      /**
       * Box Sizing
       * @see https://tailwindcss.com/docs/box-sizing
       */
      box: [{
        box: ["border", "content"]
      }],
      /**
       * Display
       * @see https://tailwindcss.com/docs/display
       */
      display: ["block", "inline-block", "inline", "flex", "inline-flex", "table", "inline-table", "table-caption", "table-cell", "table-column", "table-column-group", "table-footer-group", "table-header-group", "table-row-group", "table-row", "flow-root", "grid", "inline-grid", "contents", "list-item", "hidden"],
      /**
       * Screen Reader Only
       * @see https://tailwindcss.com/docs/display#screen-reader-only
       */
      sr: ["sr-only", "not-sr-only"],
      /**
       * Floats
       * @see https://tailwindcss.com/docs/float
       */
      float: [{
        float: ["right", "left", "none", "start", "end"]
      }],
      /**
       * Clear
       * @see https://tailwindcss.com/docs/clear
       */
      clear: [{
        clear: ["left", "right", "both", "none", "start", "end"]
      }],
      /**
       * Isolation
       * @see https://tailwindcss.com/docs/isolation
       */
      isolation: ["isolate", "isolation-auto"],
      /**
       * Object Fit
       * @see https://tailwindcss.com/docs/object-fit
       */
      "object-fit": [{
        object: ["contain", "cover", "fill", "none", "scale-down"]
      }],
      /**
       * Object Position
       * @see https://tailwindcss.com/docs/object-position
       */
      "object-position": [{
        object: H()
      }],
      /**
       * Overflow
       * @see https://tailwindcss.com/docs/overflow
       */
      overflow: [{
        overflow: M()
      }],
      /**
       * Overflow X
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-x": [{
        "overflow-x": M()
      }],
      /**
       * Overflow Y
       * @see https://tailwindcss.com/docs/overflow
       */
      "overflow-y": [{
        "overflow-y": M()
      }],
      /**
       * Overscroll Behavior
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      overscroll: [{
        overscroll: E()
      }],
      /**
       * Overscroll Behavior X
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-x": [{
        "overscroll-x": E()
      }],
      /**
       * Overscroll Behavior Y
       * @see https://tailwindcss.com/docs/overscroll-behavior
       */
      "overscroll-y": [{
        "overscroll-y": E()
      }],
      /**
       * Position
       * @see https://tailwindcss.com/docs/position
       */
      position: ["static", "fixed", "absolute", "relative", "sticky"],
      /**
       * Inset
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      inset: [{
        inset: R()
      }],
      /**
       * Inset Inline
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-x": [{
        "inset-x": R()
      }],
      /**
       * Inset Block
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-y": [{
        "inset-y": R()
      }],
      /**
       * Inset Inline Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-s` in next major release
       */
      start: [{
        "inset-s": R(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-s-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        start: R()
      }],
      /**
       * Inset Inline End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       * @todo class group will be renamed to `inset-e` in next major release
       */
      end: [{
        "inset-e": R(),
        /**
         * @deprecated since Tailwind CSS v4.2.0 in favor of `inset-e-*` utilities.
         * @see https://github.com/tailwindlabs/tailwindcss/pull/19613
         */
        end: R()
      }],
      /**
       * Inset Block Start
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-bs": [{
        "inset-bs": R()
      }],
      /**
       * Inset Block End
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      "inset-be": [{
        "inset-be": R()
      }],
      /**
       * Top
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      top: [{
        top: R()
      }],
      /**
       * Right
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      right: [{
        right: R()
      }],
      /**
       * Bottom
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      bottom: [{
        bottom: R()
      }],
      /**
       * Left
       * @see https://tailwindcss.com/docs/top-right-bottom-left
       */
      left: [{
        left: R()
      }],
      /**
       * Visibility
       * @see https://tailwindcss.com/docs/visibility
       */
      visibility: ["visible", "invisible", "collapse"],
      /**
       * Z-Index
       * @see https://tailwindcss.com/docs/z-index
       */
      z: [{
        z: [te, "auto", f, u]
      }],
      // ------------------------
      // --- Flexbox and Grid ---
      // ------------------------
      /**
       * Flex Basis
       * @see https://tailwindcss.com/docs/flex-basis
       */
      basis: [{
        basis: [ee, "full", "auto", l, ...h()]
      }],
      /**
       * Flex Direction
       * @see https://tailwindcss.com/docs/flex-direction
       */
      "flex-direction": [{
        flex: ["row", "row-reverse", "col", "col-reverse"]
      }],
      /**
       * Flex Wrap
       * @see https://tailwindcss.com/docs/flex-wrap
       */
      "flex-wrap": [{
        flex: ["nowrap", "wrap", "wrap-reverse"]
      }],
      /**
       * Flex
       * @see https://tailwindcss.com/docs/flex
       */
      flex: [{
        flex: [v, ee, "auto", "initial", "none", u]
      }],
      /**
       * Flex Grow
       * @see https://tailwindcss.com/docs/flex-grow
       */
      grow: [{
        grow: ["", v, f, u]
      }],
      /**
       * Flex Shrink
       * @see https://tailwindcss.com/docs/flex-shrink
       */
      shrink: [{
        shrink: ["", v, f, u]
      }],
      /**
       * Order
       * @see https://tailwindcss.com/docs/order
       */
      order: [{
        order: [te, "first", "last", "none", f, u]
      }],
      /**
       * Grid Template Columns
       * @see https://tailwindcss.com/docs/grid-template-columns
       */
      "grid-cols": [{
        "grid-cols": A()
      }],
      /**
       * Grid Column Start / End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start-end": [{
        col: V()
      }],
      /**
       * Grid Column Start
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-start": [{
        "col-start": $()
      }],
      /**
       * Grid Column End
       * @see https://tailwindcss.com/docs/grid-column
       */
      "col-end": [{
        "col-end": $()
      }],
      /**
       * Grid Template Rows
       * @see https://tailwindcss.com/docs/grid-template-rows
       */
      "grid-rows": [{
        "grid-rows": A()
      }],
      /**
       * Grid Row Start / End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start-end": [{
        row: V()
      }],
      /**
       * Grid Row Start
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-start": [{
        "row-start": $()
      }],
      /**
       * Grid Row End
       * @see https://tailwindcss.com/docs/grid-row
       */
      "row-end": [{
        "row-end": $()
      }],
      /**
       * Grid Auto Flow
       * @see https://tailwindcss.com/docs/grid-auto-flow
       */
      "grid-flow": [{
        "grid-flow": ["row", "col", "dense", "row-dense", "col-dense"]
      }],
      /**
       * Grid Auto Columns
       * @see https://tailwindcss.com/docs/grid-auto-columns
       */
      "auto-cols": [{
        "auto-cols": J()
      }],
      /**
       * Grid Auto Rows
       * @see https://tailwindcss.com/docs/grid-auto-rows
       */
      "auto-rows": [{
        "auto-rows": J()
      }],
      /**
       * Gap
       * @see https://tailwindcss.com/docs/gap
       */
      gap: [{
        gap: h()
      }],
      /**
       * Gap X
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-x": [{
        "gap-x": h()
      }],
      /**
       * Gap Y
       * @see https://tailwindcss.com/docs/gap
       */
      "gap-y": [{
        "gap-y": h()
      }],
      /**
       * Justify Content
       * @see https://tailwindcss.com/docs/justify-content
       */
      "justify-content": [{
        justify: [...P(), "normal"]
      }],
      /**
       * Justify Items
       * @see https://tailwindcss.com/docs/justify-items
       */
      "justify-items": [{
        "justify-items": [...N(), "normal"]
      }],
      /**
       * Justify Self
       * @see https://tailwindcss.com/docs/justify-self
       */
      "justify-self": [{
        "justify-self": ["auto", ...N()]
      }],
      /**
       * Align Content
       * @see https://tailwindcss.com/docs/align-content
       */
      "align-content": [{
        content: ["normal", ...P()]
      }],
      /**
       * Align Items
       * @see https://tailwindcss.com/docs/align-items
       */
      "align-items": [{
        items: [...N(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Align Self
       * @see https://tailwindcss.com/docs/align-self
       */
      "align-self": [{
        self: ["auto", ...N(), {
          baseline: ["", "last"]
        }]
      }],
      /**
       * Place Content
       * @see https://tailwindcss.com/docs/place-content
       */
      "place-content": [{
        "place-content": P()
      }],
      /**
       * Place Items
       * @see https://tailwindcss.com/docs/place-items
       */
      "place-items": [{
        "place-items": [...N(), "baseline"]
      }],
      /**
       * Place Self
       * @see https://tailwindcss.com/docs/place-self
       */
      "place-self": [{
        "place-self": ["auto", ...N()]
      }],
      // Spacing
      /**
       * Padding
       * @see https://tailwindcss.com/docs/padding
       */
      p: [{
        p: h()
      }],
      /**
       * Padding Inline
       * @see https://tailwindcss.com/docs/padding
       */
      px: [{
        px: h()
      }],
      /**
       * Padding Block
       * @see https://tailwindcss.com/docs/padding
       */
      py: [{
        py: h()
      }],
      /**
       * Padding Inline Start
       * @see https://tailwindcss.com/docs/padding
       */
      ps: [{
        ps: h()
      }],
      /**
       * Padding Inline End
       * @see https://tailwindcss.com/docs/padding
       */
      pe: [{
        pe: h()
      }],
      /**
       * Padding Block Start
       * @see https://tailwindcss.com/docs/padding
       */
      pbs: [{
        pbs: h()
      }],
      /**
       * Padding Block End
       * @see https://tailwindcss.com/docs/padding
       */
      pbe: [{
        pbe: h()
      }],
      /**
       * Padding Top
       * @see https://tailwindcss.com/docs/padding
       */
      pt: [{
        pt: h()
      }],
      /**
       * Padding Right
       * @see https://tailwindcss.com/docs/padding
       */
      pr: [{
        pr: h()
      }],
      /**
       * Padding Bottom
       * @see https://tailwindcss.com/docs/padding
       */
      pb: [{
        pb: h()
      }],
      /**
       * Padding Left
       * @see https://tailwindcss.com/docs/padding
       */
      pl: [{
        pl: h()
      }],
      /**
       * Margin
       * @see https://tailwindcss.com/docs/margin
       */
      m: [{
        m: B()
      }],
      /**
       * Margin Inline
       * @see https://tailwindcss.com/docs/margin
       */
      mx: [{
        mx: B()
      }],
      /**
       * Margin Block
       * @see https://tailwindcss.com/docs/margin
       */
      my: [{
        my: B()
      }],
      /**
       * Margin Inline Start
       * @see https://tailwindcss.com/docs/margin
       */
      ms: [{
        ms: B()
      }],
      /**
       * Margin Inline End
       * @see https://tailwindcss.com/docs/margin
       */
      me: [{
        me: B()
      }],
      /**
       * Margin Block Start
       * @see https://tailwindcss.com/docs/margin
       */
      mbs: [{
        mbs: B()
      }],
      /**
       * Margin Block End
       * @see https://tailwindcss.com/docs/margin
       */
      mbe: [{
        mbe: B()
      }],
      /**
       * Margin Top
       * @see https://tailwindcss.com/docs/margin
       */
      mt: [{
        mt: B()
      }],
      /**
       * Margin Right
       * @see https://tailwindcss.com/docs/margin
       */
      mr: [{
        mr: B()
      }],
      /**
       * Margin Bottom
       * @see https://tailwindcss.com/docs/margin
       */
      mb: [{
        mb: B()
      }],
      /**
       * Margin Left
       * @see https://tailwindcss.com/docs/margin
       */
      ml: [{
        ml: B()
      }],
      /**
       * Space Between X
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x": [{
        "space-x": h()
      }],
      /**
       * Space Between X Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-x-reverse": ["space-x-reverse"],
      /**
       * Space Between Y
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y": [{
        "space-y": h()
      }],
      /**
       * Space Between Y Reverse
       * @see https://tailwindcss.com/docs/margin#adding-space-between-children
       */
      "space-y-reverse": ["space-y-reverse"],
      // --------------
      // --- Sizing ---
      // --------------
      /**
       * Size
       * @see https://tailwindcss.com/docs/width#setting-both-width-and-height
       */
      size: [{
        size: Y()
      }],
      /**
       * Inline Size
       * @see https://tailwindcss.com/docs/width
       */
      "inline-size": [{
        inline: ["auto", ...x()]
      }],
      /**
       * Min-Inline Size
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-inline-size": [{
        "min-inline": ["auto", ...x()]
      }],
      /**
       * Max-Inline Size
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-inline-size": [{
        "max-inline": ["none", ...x()]
      }],
      /**
       * Block Size
       * @see https://tailwindcss.com/docs/height
       */
      "block-size": [{
        block: ["auto", ...W()]
      }],
      /**
       * Min-Block Size
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-block-size": [{
        "min-block": ["auto", ...W()]
      }],
      /**
       * Max-Block Size
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-block-size": [{
        "max-block": ["none", ...W()]
      }],
      /**
       * Width
       * @see https://tailwindcss.com/docs/width
       */
      w: [{
        w: [l, "screen", ...Y()]
      }],
      /**
       * Min-Width
       * @see https://tailwindcss.com/docs/min-width
       */
      "min-w": [{
        "min-w": [
          l,
          "screen",
          /** Deprecated. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "none",
          ...Y()
        ]
      }],
      /**
       * Max-Width
       * @see https://tailwindcss.com/docs/max-width
       */
      "max-w": [{
        "max-w": [
          l,
          "screen",
          "none",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          "prose",
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          {
            screen: [a]
          },
          ...Y()
        ]
      }],
      /**
       * Height
       * @see https://tailwindcss.com/docs/height
       */
      h: [{
        h: ["screen", "lh", ...Y()]
      }],
      /**
       * Min-Height
       * @see https://tailwindcss.com/docs/min-height
       */
      "min-h": [{
        "min-h": ["screen", "lh", "none", ...Y()]
      }],
      /**
       * Max-Height
       * @see https://tailwindcss.com/docs/max-height
       */
      "max-h": [{
        "max-h": ["screen", "lh", ...Y()]
      }],
      // ------------------
      // --- Typography ---
      // ------------------
      /**
       * Font Size
       * @see https://tailwindcss.com/docs/font-size
       */
      "font-size": [{
        text: ["base", t, de, ne]
      }],
      /**
       * Font Smoothing
       * @see https://tailwindcss.com/docs/font-smoothing
       */
      "font-smoothing": ["antialiased", "subpixel-antialiased"],
      /**
       * Font Style
       * @see https://tailwindcss.com/docs/font-style
       */
      "font-style": ["italic", "not-italic"],
      /**
       * Font Weight
       * @see https://tailwindcss.com/docs/font-weight
       */
      "font-weight": [{
        font: [o, Xt, $t]
      }],
      /**
       * Font Stretch
       * @see https://tailwindcss.com/docs/font-stretch
       */
      "font-stretch": [{
        "font-stretch": ["ultra-condensed", "extra-condensed", "condensed", "semi-condensed", "normal", "semi-expanded", "expanded", "extra-expanded", "ultra-expanded", we, u]
      }],
      /**
       * Font Family
       * @see https://tailwindcss.com/docs/font-family
       */
      "font-family": [{
        font: [Ot, _t, n]
      }],
      /**
       * Font Feature Settings
       * @see https://tailwindcss.com/docs/font-feature-settings
       */
      "font-features": [{
        "font-features": [u]
      }],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-normal": ["normal-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-ordinal": ["ordinal"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-slashed-zero": ["slashed-zero"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-figure": ["lining-nums", "oldstyle-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-spacing": ["proportional-nums", "tabular-nums"],
      /**
       * Font Variant Numeric
       * @see https://tailwindcss.com/docs/font-variant-numeric
       */
      "fvn-fraction": ["diagonal-fractions", "stacked-fractions"],
      /**
       * Letter Spacing
       * @see https://tailwindcss.com/docs/letter-spacing
       */
      tracking: [{
        tracking: [i, f, u]
      }],
      /**
       * Line Clamp
       * @see https://tailwindcss.com/docs/line-clamp
       */
      "line-clamp": [{
        "line-clamp": [v, "none", f, Be]
      }],
      /**
       * Line Height
       * @see https://tailwindcss.com/docs/line-height
       */
      leading: [{
        leading: [
          /** Deprecated since Tailwind CSS v4.0.0. @see https://github.com/tailwindlabs/tailwindcss.com/issues/2027#issuecomment-2620152757 */
          s,
          ...h()
        ]
      }],
      /**
       * List Style Image
       * @see https://tailwindcss.com/docs/list-style-image
       */
      "list-image": [{
        "list-image": ["none", f, u]
      }],
      /**
       * List Style Position
       * @see https://tailwindcss.com/docs/list-style-position
       */
      "list-style-position": [{
        list: ["inside", "outside"]
      }],
      /**
       * List Style Type
       * @see https://tailwindcss.com/docs/list-style-type
       */
      "list-style-type": [{
        list: ["disc", "decimal", "none", f, u]
      }],
      /**
       * Text Alignment
       * @see https://tailwindcss.com/docs/text-align
       */
      "text-alignment": [{
        text: ["left", "center", "right", "justify", "start", "end"]
      }],
      /**
       * Placeholder Color
       * @deprecated since Tailwind CSS v3.0.0
       * @see https://v3.tailwindcss.com/docs/placeholder-color
       */
      "placeholder-color": [{
        placeholder: b()
      }],
      /**
       * Text Color
       * @see https://tailwindcss.com/docs/text-color
       */
      "text-color": [{
        text: b()
      }],
      /**
       * Text Decoration
       * @see https://tailwindcss.com/docs/text-decoration
       */
      "text-decoration": ["underline", "overline", "line-through", "no-underline"],
      /**
       * Text Decoration Style
       * @see https://tailwindcss.com/docs/text-decoration-style
       */
      "text-decoration-style": [{
        decoration: [...K(), "wavy"]
      }],
      /**
       * Text Decoration Thickness
       * @see https://tailwindcss.com/docs/text-decoration-thickness
       */
      "text-decoration-thickness": [{
        decoration: [v, "from-font", "auto", f, ne]
      }],
      /**
       * Text Decoration Color
       * @see https://tailwindcss.com/docs/text-decoration-color
       */
      "text-decoration-color": [{
        decoration: b()
      }],
      /**
       * Text Underline Offset
       * @see https://tailwindcss.com/docs/text-underline-offset
       */
      "underline-offset": [{
        "underline-offset": [v, "auto", f, u]
      }],
      /**
       * Text Transform
       * @see https://tailwindcss.com/docs/text-transform
       */
      "text-transform": ["uppercase", "lowercase", "capitalize", "normal-case"],
      /**
       * Text Overflow
       * @see https://tailwindcss.com/docs/text-overflow
       */
      "text-overflow": ["truncate", "text-ellipsis", "text-clip"],
      /**
       * Text Wrap
       * @see https://tailwindcss.com/docs/text-wrap
       */
      "text-wrap": [{
        text: ["wrap", "nowrap", "balance", "pretty"]
      }],
      /**
       * Text Indent
       * @see https://tailwindcss.com/docs/text-indent
       */
      indent: [{
        indent: h()
      }],
      /**
       * Vertical Alignment
       * @see https://tailwindcss.com/docs/vertical-align
       */
      "vertical-align": [{
        align: ["baseline", "top", "middle", "bottom", "text-top", "text-bottom", "sub", "super", f, u]
      }],
      /**
       * Whitespace
       * @see https://tailwindcss.com/docs/whitespace
       */
      whitespace: [{
        whitespace: ["normal", "nowrap", "pre", "pre-line", "pre-wrap", "break-spaces"]
      }],
      /**
       * Word Break
       * @see https://tailwindcss.com/docs/word-break
       */
      break: [{
        break: ["normal", "words", "all", "keep"]
      }],
      /**
       * Overflow Wrap
       * @see https://tailwindcss.com/docs/overflow-wrap
       */
      wrap: [{
        wrap: ["break-word", "anywhere", "normal"]
      }],
      /**
       * Hyphens
       * @see https://tailwindcss.com/docs/hyphens
       */
      hyphens: [{
        hyphens: ["none", "manual", "auto"]
      }],
      /**
       * Content
       * @see https://tailwindcss.com/docs/content
       */
      content: [{
        content: ["none", f, u]
      }],
      // -------------------
      // --- Backgrounds ---
      // -------------------
      /**
       * Background Attachment
       * @see https://tailwindcss.com/docs/background-attachment
       */
      "bg-attachment": [{
        bg: ["fixed", "local", "scroll"]
      }],
      /**
       * Background Clip
       * @see https://tailwindcss.com/docs/background-clip
       */
      "bg-clip": [{
        "bg-clip": ["border", "padding", "content", "text"]
      }],
      /**
       * Background Origin
       * @see https://tailwindcss.com/docs/background-origin
       */
      "bg-origin": [{
        "bg-origin": ["border", "padding", "content"]
      }],
      /**
       * Background Position
       * @see https://tailwindcss.com/docs/background-position
       */
      "bg-position": [{
        bg: ce()
      }],
      /**
       * Background Repeat
       * @see https://tailwindcss.com/docs/background-repeat
       */
      "bg-repeat": [{
        bg: C()
      }],
      /**
       * Background Size
       * @see https://tailwindcss.com/docs/background-size
       */
      "bg-size": [{
        bg: X()
      }],
      /**
       * Background Image
       * @see https://tailwindcss.com/docs/background-image
       */
      "bg-image": [{
        bg: ["none", {
          linear: [{
            to: ["t", "tr", "r", "br", "b", "bl", "l", "tl"]
          }, te, f, u],
          radial: ["", f, u],
          conic: [te, f, u]
        }, Ht, Pt]
      }],
      /**
       * Background Color
       * @see https://tailwindcss.com/docs/background-color
       */
      "bg-color": [{
        bg: b()
      }],
      /**
       * Gradient Color Stops From Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from-pos": [{
        from: Z()
      }],
      /**
       * Gradient Color Stops Via Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via-pos": [{
        via: Z()
      }],
      /**
       * Gradient Color Stops To Position
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to-pos": [{
        to: Z()
      }],
      /**
       * Gradient Color Stops From
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-from": [{
        from: b()
      }],
      /**
       * Gradient Color Stops Via
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-via": [{
        via: b()
      }],
      /**
       * Gradient Color Stops To
       * @see https://tailwindcss.com/docs/gradient-color-stops
       */
      "gradient-to": [{
        to: b()
      }],
      // ---------------
      // --- Borders ---
      // ---------------
      /**
       * Border Radius
       * @see https://tailwindcss.com/docs/border-radius
       */
      rounded: [{
        rounded: T()
      }],
      /**
       * Border Radius Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-s": [{
        "rounded-s": T()
      }],
      /**
       * Border Radius End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-e": [{
        "rounded-e": T()
      }],
      /**
       * Border Radius Top
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-t": [{
        "rounded-t": T()
      }],
      /**
       * Border Radius Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-r": [{
        "rounded-r": T()
      }],
      /**
       * Border Radius Bottom
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-b": [{
        "rounded-b": T()
      }],
      /**
       * Border Radius Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-l": [{
        "rounded-l": T()
      }],
      /**
       * Border Radius Start Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ss": [{
        "rounded-ss": T()
      }],
      /**
       * Border Radius Start End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-se": [{
        "rounded-se": T()
      }],
      /**
       * Border Radius End End
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-ee": [{
        "rounded-ee": T()
      }],
      /**
       * Border Radius End Start
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-es": [{
        "rounded-es": T()
      }],
      /**
       * Border Radius Top Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tl": [{
        "rounded-tl": T()
      }],
      /**
       * Border Radius Top Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-tr": [{
        "rounded-tr": T()
      }],
      /**
       * Border Radius Bottom Right
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-br": [{
        "rounded-br": T()
      }],
      /**
       * Border Radius Bottom Left
       * @see https://tailwindcss.com/docs/border-radius
       */
      "rounded-bl": [{
        "rounded-bl": T()
      }],
      /**
       * Border Width
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w": [{
        border: _()
      }],
      /**
       * Border Width Inline
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-x": [{
        "border-x": _()
      }],
      /**
       * Border Width Block
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-y": [{
        "border-y": _()
      }],
      /**
       * Border Width Inline Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-s": [{
        "border-s": _()
      }],
      /**
       * Border Width Inline End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-e": [{
        "border-e": _()
      }],
      /**
       * Border Width Block Start
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-bs": [{
        "border-bs": _()
      }],
      /**
       * Border Width Block End
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-be": [{
        "border-be": _()
      }],
      /**
       * Border Width Top
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-t": [{
        "border-t": _()
      }],
      /**
       * Border Width Right
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-r": [{
        "border-r": _()
      }],
      /**
       * Border Width Bottom
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-b": [{
        "border-b": _()
      }],
      /**
       * Border Width Left
       * @see https://tailwindcss.com/docs/border-width
       */
      "border-w-l": [{
        "border-l": _()
      }],
      /**
       * Divide Width X
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x": [{
        "divide-x": _()
      }],
      /**
       * Divide Width X Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-x-reverse": ["divide-x-reverse"],
      /**
       * Divide Width Y
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y": [{
        "divide-y": _()
      }],
      /**
       * Divide Width Y Reverse
       * @see https://tailwindcss.com/docs/border-width#between-children
       */
      "divide-y-reverse": ["divide-y-reverse"],
      /**
       * Border Style
       * @see https://tailwindcss.com/docs/border-style
       */
      "border-style": [{
        border: [...K(), "hidden", "none"]
      }],
      /**
       * Divide Style
       * @see https://tailwindcss.com/docs/border-style#setting-the-divider-style
       */
      "divide-style": [{
        divide: [...K(), "hidden", "none"]
      }],
      /**
       * Border Color
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color": [{
        border: b()
      }],
      /**
       * Border Color Inline
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-x": [{
        "border-x": b()
      }],
      /**
       * Border Color Block
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-y": [{
        "border-y": b()
      }],
      /**
       * Border Color Inline Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-s": [{
        "border-s": b()
      }],
      /**
       * Border Color Inline End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-e": [{
        "border-e": b()
      }],
      /**
       * Border Color Block Start
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-bs": [{
        "border-bs": b()
      }],
      /**
       * Border Color Block End
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-be": [{
        "border-be": b()
      }],
      /**
       * Border Color Top
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-t": [{
        "border-t": b()
      }],
      /**
       * Border Color Right
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-r": [{
        "border-r": b()
      }],
      /**
       * Border Color Bottom
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-b": [{
        "border-b": b()
      }],
      /**
       * Border Color Left
       * @see https://tailwindcss.com/docs/border-color
       */
      "border-color-l": [{
        "border-l": b()
      }],
      /**
       * Divide Color
       * @see https://tailwindcss.com/docs/divide-color
       */
      "divide-color": [{
        divide: b()
      }],
      /**
       * Outline Style
       * @see https://tailwindcss.com/docs/outline-style
       */
      "outline-style": [{
        outline: [...K(), "none", "hidden"]
      }],
      /**
       * Outline Offset
       * @see https://tailwindcss.com/docs/outline-offset
       */
      "outline-offset": [{
        "outline-offset": [v, f, u]
      }],
      /**
       * Outline Width
       * @see https://tailwindcss.com/docs/outline-width
       */
      "outline-w": [{
        outline: ["", v, de, ne]
      }],
      /**
       * Outline Color
       * @see https://tailwindcss.com/docs/outline-color
       */
      "outline-color": [{
        outline: b()
      }],
      // ---------------
      // --- Effects ---
      // ---------------
      /**
       * Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow
       */
      shadow: [{
        shadow: [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          p,
          be,
          pe
        ]
      }],
      /**
       * Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-shadow-color
       */
      "shadow-color": [{
        shadow: b()
      }],
      /**
       * Inset Box Shadow
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-shadow
       */
      "inset-shadow": [{
        "inset-shadow": ["none", g, be, pe]
      }],
      /**
       * Inset Box Shadow Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-shadow-color
       */
      "inset-shadow-color": [{
        "inset-shadow": b()
      }],
      /**
       * Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-a-ring
       */
      "ring-w": [{
        ring: _()
      }],
      /**
       * Ring Width Inset
       * @see https://v3.tailwindcss.com/docs/ring-width#inset-rings
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-w-inset": ["ring-inset"],
      /**
       * Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-ring-color
       */
      "ring-color": [{
        ring: b()
      }],
      /**
       * Ring Offset Width
       * @see https://v3.tailwindcss.com/docs/ring-offset-width
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-w": [{
        "ring-offset": [v, ne]
      }],
      /**
       * Ring Offset Color
       * @see https://v3.tailwindcss.com/docs/ring-offset-color
       * @deprecated since Tailwind CSS v4.0.0
       * @see https://github.com/tailwindlabs/tailwindcss/blob/v4.0.0/packages/tailwindcss/src/utilities.ts#L4158
       */
      "ring-offset-color": [{
        "ring-offset": b()
      }],
      /**
       * Inset Ring Width
       * @see https://tailwindcss.com/docs/box-shadow#adding-an-inset-ring
       */
      "inset-ring-w": [{
        "inset-ring": _()
      }],
      /**
       * Inset Ring Color
       * @see https://tailwindcss.com/docs/box-shadow#setting-the-inset-ring-color
       */
      "inset-ring-color": [{
        "inset-ring": b()
      }],
      /**
       * Text Shadow
       * @see https://tailwindcss.com/docs/text-shadow
       */
      "text-shadow": [{
        "text-shadow": ["none", k, be, pe]
      }],
      /**
       * Text Shadow Color
       * @see https://tailwindcss.com/docs/text-shadow#setting-the-shadow-color
       */
      "text-shadow-color": [{
        "text-shadow": b()
      }],
      /**
       * Opacity
       * @see https://tailwindcss.com/docs/opacity
       */
      opacity: [{
        opacity: [v, f, u]
      }],
      /**
       * Mix Blend Mode
       * @see https://tailwindcss.com/docs/mix-blend-mode
       */
      "mix-blend": [{
        "mix-blend": [...q(), "plus-darker", "plus-lighter"]
      }],
      /**
       * Background Blend Mode
       * @see https://tailwindcss.com/docs/background-blend-mode
       */
      "bg-blend": [{
        "bg-blend": q()
      }],
      /**
       * Mask Clip
       * @see https://tailwindcss.com/docs/mask-clip
       */
      "mask-clip": [{
        "mask-clip": ["border", "padding", "content", "fill", "stroke", "view"]
      }, "mask-no-clip"],
      /**
       * Mask Composite
       * @see https://tailwindcss.com/docs/mask-composite
       */
      "mask-composite": [{
        mask: ["add", "subtract", "intersect", "exclude"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image-linear-pos": [{
        "mask-linear": [v]
      }],
      "mask-image-linear-from-pos": [{
        "mask-linear-from": L()
      }],
      "mask-image-linear-to-pos": [{
        "mask-linear-to": L()
      }],
      "mask-image-linear-from-color": [{
        "mask-linear-from": b()
      }],
      "mask-image-linear-to-color": [{
        "mask-linear-to": b()
      }],
      "mask-image-t-from-pos": [{
        "mask-t-from": L()
      }],
      "mask-image-t-to-pos": [{
        "mask-t-to": L()
      }],
      "mask-image-t-from-color": [{
        "mask-t-from": b()
      }],
      "mask-image-t-to-color": [{
        "mask-t-to": b()
      }],
      "mask-image-r-from-pos": [{
        "mask-r-from": L()
      }],
      "mask-image-r-to-pos": [{
        "mask-r-to": L()
      }],
      "mask-image-r-from-color": [{
        "mask-r-from": b()
      }],
      "mask-image-r-to-color": [{
        "mask-r-to": b()
      }],
      "mask-image-b-from-pos": [{
        "mask-b-from": L()
      }],
      "mask-image-b-to-pos": [{
        "mask-b-to": L()
      }],
      "mask-image-b-from-color": [{
        "mask-b-from": b()
      }],
      "mask-image-b-to-color": [{
        "mask-b-to": b()
      }],
      "mask-image-l-from-pos": [{
        "mask-l-from": L()
      }],
      "mask-image-l-to-pos": [{
        "mask-l-to": L()
      }],
      "mask-image-l-from-color": [{
        "mask-l-from": b()
      }],
      "mask-image-l-to-color": [{
        "mask-l-to": b()
      }],
      "mask-image-x-from-pos": [{
        "mask-x-from": L()
      }],
      "mask-image-x-to-pos": [{
        "mask-x-to": L()
      }],
      "mask-image-x-from-color": [{
        "mask-x-from": b()
      }],
      "mask-image-x-to-color": [{
        "mask-x-to": b()
      }],
      "mask-image-y-from-pos": [{
        "mask-y-from": L()
      }],
      "mask-image-y-to-pos": [{
        "mask-y-to": L()
      }],
      "mask-image-y-from-color": [{
        "mask-y-from": b()
      }],
      "mask-image-y-to-color": [{
        "mask-y-to": b()
      }],
      "mask-image-radial": [{
        "mask-radial": [f, u]
      }],
      "mask-image-radial-from-pos": [{
        "mask-radial-from": L()
      }],
      "mask-image-radial-to-pos": [{
        "mask-radial-to": L()
      }],
      "mask-image-radial-from-color": [{
        "mask-radial-from": b()
      }],
      "mask-image-radial-to-color": [{
        "mask-radial-to": b()
      }],
      "mask-image-radial-shape": [{
        "mask-radial": ["circle", "ellipse"]
      }],
      "mask-image-radial-size": [{
        "mask-radial": [{
          closest: ["side", "corner"],
          farthest: ["side", "corner"]
        }]
      }],
      "mask-image-radial-pos": [{
        "mask-radial-at": G()
      }],
      "mask-image-conic-pos": [{
        "mask-conic": [v]
      }],
      "mask-image-conic-from-pos": [{
        "mask-conic-from": L()
      }],
      "mask-image-conic-to-pos": [{
        "mask-conic-to": L()
      }],
      "mask-image-conic-from-color": [{
        "mask-conic-from": b()
      }],
      "mask-image-conic-to-color": [{
        "mask-conic-to": b()
      }],
      /**
       * Mask Mode
       * @see https://tailwindcss.com/docs/mask-mode
       */
      "mask-mode": [{
        mask: ["alpha", "luminance", "match"]
      }],
      /**
       * Mask Origin
       * @see https://tailwindcss.com/docs/mask-origin
       */
      "mask-origin": [{
        "mask-origin": ["border", "padding", "content", "fill", "stroke", "view"]
      }],
      /**
       * Mask Position
       * @see https://tailwindcss.com/docs/mask-position
       */
      "mask-position": [{
        mask: ce()
      }],
      /**
       * Mask Repeat
       * @see https://tailwindcss.com/docs/mask-repeat
       */
      "mask-repeat": [{
        mask: C()
      }],
      /**
       * Mask Size
       * @see https://tailwindcss.com/docs/mask-size
       */
      "mask-size": [{
        mask: X()
      }],
      /**
       * Mask Type
       * @see https://tailwindcss.com/docs/mask-type
       */
      "mask-type": [{
        "mask-type": ["alpha", "luminance"]
      }],
      /**
       * Mask Image
       * @see https://tailwindcss.com/docs/mask-image
       */
      "mask-image": [{
        mask: ["none", f, u]
      }],
      // ---------------
      // --- Filters ---
      // ---------------
      /**
       * Filter
       * @see https://tailwindcss.com/docs/filter
       */
      filter: [{
        filter: [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          f,
          u
        ]
      }],
      /**
       * Blur
       * @see https://tailwindcss.com/docs/blur
       */
      blur: [{
        blur: Ie()
      }],
      /**
       * Brightness
       * @see https://tailwindcss.com/docs/brightness
       */
      brightness: [{
        brightness: [v, f, u]
      }],
      /**
       * Contrast
       * @see https://tailwindcss.com/docs/contrast
       */
      contrast: [{
        contrast: [v, f, u]
      }],
      /**
       * Drop Shadow
       * @see https://tailwindcss.com/docs/drop-shadow
       */
      "drop-shadow": [{
        "drop-shadow": [
          // Deprecated since Tailwind CSS v4.0.0
          "",
          "none",
          y,
          be,
          pe
        ]
      }],
      /**
       * Drop Shadow Color
       * @see https://tailwindcss.com/docs/filter-drop-shadow#setting-the-shadow-color
       */
      "drop-shadow-color": [{
        "drop-shadow": b()
      }],
      /**
       * Grayscale
       * @see https://tailwindcss.com/docs/grayscale
       */
      grayscale: [{
        grayscale: ["", v, f, u]
      }],
      /**
       * Hue Rotate
       * @see https://tailwindcss.com/docs/hue-rotate
       */
      "hue-rotate": [{
        "hue-rotate": [v, f, u]
      }],
      /**
       * Invert
       * @see https://tailwindcss.com/docs/invert
       */
      invert: [{
        invert: ["", v, f, u]
      }],
      /**
       * Saturate
       * @see https://tailwindcss.com/docs/saturate
       */
      saturate: [{
        saturate: [v, f, u]
      }],
      /**
       * Sepia
       * @see https://tailwindcss.com/docs/sepia
       */
      sepia: [{
        sepia: ["", v, f, u]
      }],
      /**
       * Backdrop Filter
       * @see https://tailwindcss.com/docs/backdrop-filter
       */
      "backdrop-filter": [{
        "backdrop-filter": [
          // Deprecated since Tailwind CSS v3.0.0
          "",
          "none",
          f,
          u
        ]
      }],
      /**
       * Backdrop Blur
       * @see https://tailwindcss.com/docs/backdrop-blur
       */
      "backdrop-blur": [{
        "backdrop-blur": Ie()
      }],
      /**
       * Backdrop Brightness
       * @see https://tailwindcss.com/docs/backdrop-brightness
       */
      "backdrop-brightness": [{
        "backdrop-brightness": [v, f, u]
      }],
      /**
       * Backdrop Contrast
       * @see https://tailwindcss.com/docs/backdrop-contrast
       */
      "backdrop-contrast": [{
        "backdrop-contrast": [v, f, u]
      }],
      /**
       * Backdrop Grayscale
       * @see https://tailwindcss.com/docs/backdrop-grayscale
       */
      "backdrop-grayscale": [{
        "backdrop-grayscale": ["", v, f, u]
      }],
      /**
       * Backdrop Hue Rotate
       * @see https://tailwindcss.com/docs/backdrop-hue-rotate
       */
      "backdrop-hue-rotate": [{
        "backdrop-hue-rotate": [v, f, u]
      }],
      /**
       * Backdrop Invert
       * @see https://tailwindcss.com/docs/backdrop-invert
       */
      "backdrop-invert": [{
        "backdrop-invert": ["", v, f, u]
      }],
      /**
       * Backdrop Opacity
       * @see https://tailwindcss.com/docs/backdrop-opacity
       */
      "backdrop-opacity": [{
        "backdrop-opacity": [v, f, u]
      }],
      /**
       * Backdrop Saturate
       * @see https://tailwindcss.com/docs/backdrop-saturate
       */
      "backdrop-saturate": [{
        "backdrop-saturate": [v, f, u]
      }],
      /**
       * Backdrop Sepia
       * @see https://tailwindcss.com/docs/backdrop-sepia
       */
      "backdrop-sepia": [{
        "backdrop-sepia": ["", v, f, u]
      }],
      // --------------
      // --- Tables ---
      // --------------
      /**
       * Border Collapse
       * @see https://tailwindcss.com/docs/border-collapse
       */
      "border-collapse": [{
        border: ["collapse", "separate"]
      }],
      /**
       * Border Spacing
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing": [{
        "border-spacing": h()
      }],
      /**
       * Border Spacing X
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-x": [{
        "border-spacing-x": h()
      }],
      /**
       * Border Spacing Y
       * @see https://tailwindcss.com/docs/border-spacing
       */
      "border-spacing-y": [{
        "border-spacing-y": h()
      }],
      /**
       * Table Layout
       * @see https://tailwindcss.com/docs/table-layout
       */
      "table-layout": [{
        table: ["auto", "fixed"]
      }],
      /**
       * Caption Side
       * @see https://tailwindcss.com/docs/caption-side
       */
      caption: [{
        caption: ["top", "bottom"]
      }],
      // ---------------------------------
      // --- Transitions and Animation ---
      // ---------------------------------
      /**
       * Transition Property
       * @see https://tailwindcss.com/docs/transition-property
       */
      transition: [{
        transition: ["", "all", "colors", "opacity", "shadow", "transform", "none", f, u]
      }],
      /**
       * Transition Behavior
       * @see https://tailwindcss.com/docs/transition-behavior
       */
      "transition-behavior": [{
        transition: ["normal", "discrete"]
      }],
      /**
       * Transition Duration
       * @see https://tailwindcss.com/docs/transition-duration
       */
      duration: [{
        duration: [v, "initial", f, u]
      }],
      /**
       * Transition Timing Function
       * @see https://tailwindcss.com/docs/transition-timing-function
       */
      ease: [{
        ease: ["linear", "initial", F, f, u]
      }],
      /**
       * Transition Delay
       * @see https://tailwindcss.com/docs/transition-delay
       */
      delay: [{
        delay: [v, f, u]
      }],
      /**
       * Animation
       * @see https://tailwindcss.com/docs/animation
       */
      animate: [{
        animate: ["none", S, f, u]
      }],
      // ------------------
      // --- Transforms ---
      // ------------------
      /**
       * Backface Visibility
       * @see https://tailwindcss.com/docs/backface-visibility
       */
      backface: [{
        backface: ["hidden", "visible"]
      }],
      /**
       * Perspective
       * @see https://tailwindcss.com/docs/perspective
       */
      perspective: [{
        perspective: [z, f, u]
      }],
      /**
       * Perspective Origin
       * @see https://tailwindcss.com/docs/perspective-origin
       */
      "perspective-origin": [{
        "perspective-origin": H()
      }],
      /**
       * Rotate
       * @see https://tailwindcss.com/docs/rotate
       */
      rotate: [{
        rotate: ue()
      }],
      /**
       * Rotate X
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-x": [{
        "rotate-x": ue()
      }],
      /**
       * Rotate Y
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-y": [{
        "rotate-y": ue()
      }],
      /**
       * Rotate Z
       * @see https://tailwindcss.com/docs/rotate
       */
      "rotate-z": [{
        "rotate-z": ue()
      }],
      /**
       * Scale
       * @see https://tailwindcss.com/docs/scale
       */
      scale: [{
        scale: fe()
      }],
      /**
       * Scale X
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-x": [{
        "scale-x": fe()
      }],
      /**
       * Scale Y
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-y": [{
        "scale-y": fe()
      }],
      /**
       * Scale Z
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-z": [{
        "scale-z": fe()
      }],
      /**
       * Scale 3D
       * @see https://tailwindcss.com/docs/scale
       */
      "scale-3d": ["scale-3d"],
      /**
       * Skew
       * @see https://tailwindcss.com/docs/skew
       */
      skew: [{
        skew: ye()
      }],
      /**
       * Skew X
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-x": [{
        "skew-x": ye()
      }],
      /**
       * Skew Y
       * @see https://tailwindcss.com/docs/skew
       */
      "skew-y": [{
        "skew-y": ye()
      }],
      /**
       * Transform
       * @see https://tailwindcss.com/docs/transform
       */
      transform: [{
        transform: [f, u, "", "none", "gpu", "cpu"]
      }],
      /**
       * Transform Origin
       * @see https://tailwindcss.com/docs/transform-origin
       */
      "transform-origin": [{
        origin: H()
      }],
      /**
       * Transform Style
       * @see https://tailwindcss.com/docs/transform-style
       */
      "transform-style": [{
        transform: ["3d", "flat"]
      }],
      /**
       * Translate
       * @see https://tailwindcss.com/docs/translate
       */
      translate: [{
        translate: he()
      }],
      /**
       * Translate X
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-x": [{
        "translate-x": he()
      }],
      /**
       * Translate Y
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-y": [{
        "translate-y": he()
      }],
      /**
       * Translate Z
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-z": [{
        "translate-z": he()
      }],
      /**
       * Translate None
       * @see https://tailwindcss.com/docs/translate
       */
      "translate-none": ["translate-none"],
      // ---------------------
      // --- Interactivity ---
      // ---------------------
      /**
       * Accent Color
       * @see https://tailwindcss.com/docs/accent-color
       */
      accent: [{
        accent: b()
      }],
      /**
       * Appearance
       * @see https://tailwindcss.com/docs/appearance
       */
      appearance: [{
        appearance: ["none", "auto"]
      }],
      /**
       * Caret Color
       * @see https://tailwindcss.com/docs/just-in-time-mode#caret-color-utilities
       */
      "caret-color": [{
        caret: b()
      }],
      /**
       * Color Scheme
       * @see https://tailwindcss.com/docs/color-scheme
       */
      "color-scheme": [{
        scheme: ["normal", "dark", "light", "light-dark", "only-dark", "only-light"]
      }],
      /**
       * Cursor
       * @see https://tailwindcss.com/docs/cursor
       */
      cursor: [{
        cursor: ["auto", "default", "pointer", "wait", "text", "move", "help", "not-allowed", "none", "context-menu", "progress", "cell", "crosshair", "vertical-text", "alias", "copy", "no-drop", "grab", "grabbing", "all-scroll", "col-resize", "row-resize", "n-resize", "e-resize", "s-resize", "w-resize", "ne-resize", "nw-resize", "se-resize", "sw-resize", "ew-resize", "ns-resize", "nesw-resize", "nwse-resize", "zoom-in", "zoom-out", f, u]
      }],
      /**
       * Field Sizing
       * @see https://tailwindcss.com/docs/field-sizing
       */
      "field-sizing": [{
        "field-sizing": ["fixed", "content"]
      }],
      /**
       * Pointer Events
       * @see https://tailwindcss.com/docs/pointer-events
       */
      "pointer-events": [{
        "pointer-events": ["auto", "none"]
      }],
      /**
       * Resize
       * @see https://tailwindcss.com/docs/resize
       */
      resize: [{
        resize: ["none", "", "y", "x"]
      }],
      /**
       * Scroll Behavior
       * @see https://tailwindcss.com/docs/scroll-behavior
       */
      "scroll-behavior": [{
        scroll: ["auto", "smooth"]
      }],
      /**
       * Scroll Margin
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-m": [{
        "scroll-m": h()
      }],
      /**
       * Scroll Margin Inline
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mx": [{
        "scroll-mx": h()
      }],
      /**
       * Scroll Margin Block
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-my": [{
        "scroll-my": h()
      }],
      /**
       * Scroll Margin Inline Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ms": [{
        "scroll-ms": h()
      }],
      /**
       * Scroll Margin Inline End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-me": [{
        "scroll-me": h()
      }],
      /**
       * Scroll Margin Block Start
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbs": [{
        "scroll-mbs": h()
      }],
      /**
       * Scroll Margin Block End
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mbe": [{
        "scroll-mbe": h()
      }],
      /**
       * Scroll Margin Top
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mt": [{
        "scroll-mt": h()
      }],
      /**
       * Scroll Margin Right
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mr": [{
        "scroll-mr": h()
      }],
      /**
       * Scroll Margin Bottom
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-mb": [{
        "scroll-mb": h()
      }],
      /**
       * Scroll Margin Left
       * @see https://tailwindcss.com/docs/scroll-margin
       */
      "scroll-ml": [{
        "scroll-ml": h()
      }],
      /**
       * Scroll Padding
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-p": [{
        "scroll-p": h()
      }],
      /**
       * Scroll Padding Inline
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-px": [{
        "scroll-px": h()
      }],
      /**
       * Scroll Padding Block
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-py": [{
        "scroll-py": h()
      }],
      /**
       * Scroll Padding Inline Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-ps": [{
        "scroll-ps": h()
      }],
      /**
       * Scroll Padding Inline End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pe": [{
        "scroll-pe": h()
      }],
      /**
       * Scroll Padding Block Start
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbs": [{
        "scroll-pbs": h()
      }],
      /**
       * Scroll Padding Block End
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pbe": [{
        "scroll-pbe": h()
      }],
      /**
       * Scroll Padding Top
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pt": [{
        "scroll-pt": h()
      }],
      /**
       * Scroll Padding Right
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pr": [{
        "scroll-pr": h()
      }],
      /**
       * Scroll Padding Bottom
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pb": [{
        "scroll-pb": h()
      }],
      /**
       * Scroll Padding Left
       * @see https://tailwindcss.com/docs/scroll-padding
       */
      "scroll-pl": [{
        "scroll-pl": h()
      }],
      /**
       * Scroll Snap Align
       * @see https://tailwindcss.com/docs/scroll-snap-align
       */
      "snap-align": [{
        snap: ["start", "end", "center", "align-none"]
      }],
      /**
       * Scroll Snap Stop
       * @see https://tailwindcss.com/docs/scroll-snap-stop
       */
      "snap-stop": [{
        snap: ["normal", "always"]
      }],
      /**
       * Scroll Snap Type
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-type": [{
        snap: ["none", "x", "y", "both"]
      }],
      /**
       * Scroll Snap Type Strictness
       * @see https://tailwindcss.com/docs/scroll-snap-type
       */
      "snap-strictness": [{
        snap: ["mandatory", "proximity"]
      }],
      /**
       * Touch Action
       * @see https://tailwindcss.com/docs/touch-action
       */
      touch: [{
        touch: ["auto", "none", "manipulation"]
      }],
      /**
       * Touch Action X
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-x": [{
        "touch-pan": ["x", "left", "right"]
      }],
      /**
       * Touch Action Y
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-y": [{
        "touch-pan": ["y", "up", "down"]
      }],
      /**
       * Touch Action Pinch Zoom
       * @see https://tailwindcss.com/docs/touch-action
       */
      "touch-pz": ["touch-pinch-zoom"],
      /**
       * User Select
       * @see https://tailwindcss.com/docs/user-select
       */
      select: [{
        select: ["none", "text", "all", "auto"]
      }],
      /**
       * Will Change
       * @see https://tailwindcss.com/docs/will-change
       */
      "will-change": [{
        "will-change": ["auto", "scroll", "contents", "transform", f, u]
      }],
      // -----------
      // --- SVG ---
      // -----------
      /**
       * Fill
       * @see https://tailwindcss.com/docs/fill
       */
      fill: [{
        fill: ["none", ...b()]
      }],
      /**
       * Stroke Width
       * @see https://tailwindcss.com/docs/stroke-width
       */
      "stroke-w": [{
        stroke: [v, de, ne, Be]
      }],
      /**
       * Stroke
       * @see https://tailwindcss.com/docs/stroke
       */
      stroke: [{
        stroke: ["none", ...b()]
      }],
      // ---------------------
      // --- Accessibility ---
      // ---------------------
      /**
       * Forced Color Adjust
       * @see https://tailwindcss.com/docs/forced-color-adjust
       */
      "forced-color-adjust": [{
        "forced-color-adjust": ["auto", "none"]
      }]
    },
    conflictingClassGroups: {
      overflow: ["overflow-x", "overflow-y"],
      overscroll: ["overscroll-x", "overscroll-y"],
      inset: ["inset-x", "inset-y", "inset-bs", "inset-be", "start", "end", "top", "right", "bottom", "left"],
      "inset-x": ["right", "left"],
      "inset-y": ["top", "bottom"],
      flex: ["basis", "grow", "shrink"],
      gap: ["gap-x", "gap-y"],
      p: ["px", "py", "ps", "pe", "pbs", "pbe", "pt", "pr", "pb", "pl"],
      px: ["pr", "pl"],
      py: ["pt", "pb"],
      m: ["mx", "my", "ms", "me", "mbs", "mbe", "mt", "mr", "mb", "ml"],
      mx: ["mr", "ml"],
      my: ["mt", "mb"],
      size: ["w", "h"],
      "font-size": ["leading"],
      "fvn-normal": ["fvn-ordinal", "fvn-slashed-zero", "fvn-figure", "fvn-spacing", "fvn-fraction"],
      "fvn-ordinal": ["fvn-normal"],
      "fvn-slashed-zero": ["fvn-normal"],
      "fvn-figure": ["fvn-normal"],
      "fvn-spacing": ["fvn-normal"],
      "fvn-fraction": ["fvn-normal"],
      "line-clamp": ["display", "overflow"],
      rounded: ["rounded-s", "rounded-e", "rounded-t", "rounded-r", "rounded-b", "rounded-l", "rounded-ss", "rounded-se", "rounded-ee", "rounded-es", "rounded-tl", "rounded-tr", "rounded-br", "rounded-bl"],
      "rounded-s": ["rounded-ss", "rounded-es"],
      "rounded-e": ["rounded-se", "rounded-ee"],
      "rounded-t": ["rounded-tl", "rounded-tr"],
      "rounded-r": ["rounded-tr", "rounded-br"],
      "rounded-b": ["rounded-br", "rounded-bl"],
      "rounded-l": ["rounded-tl", "rounded-bl"],
      "border-spacing": ["border-spacing-x", "border-spacing-y"],
      "border-w": ["border-w-x", "border-w-y", "border-w-s", "border-w-e", "border-w-bs", "border-w-be", "border-w-t", "border-w-r", "border-w-b", "border-w-l"],
      "border-w-x": ["border-w-r", "border-w-l"],
      "border-w-y": ["border-w-t", "border-w-b"],
      "border-color": ["border-color-x", "border-color-y", "border-color-s", "border-color-e", "border-color-bs", "border-color-be", "border-color-t", "border-color-r", "border-color-b", "border-color-l"],
      "border-color-x": ["border-color-r", "border-color-l"],
      "border-color-y": ["border-color-t", "border-color-b"],
      translate: ["translate-x", "translate-y", "translate-none"],
      "translate-none": ["translate", "translate-x", "translate-y", "translate-z"],
      "scroll-m": ["scroll-mx", "scroll-my", "scroll-ms", "scroll-me", "scroll-mbs", "scroll-mbe", "scroll-mt", "scroll-mr", "scroll-mb", "scroll-ml"],
      "scroll-mx": ["scroll-mr", "scroll-ml"],
      "scroll-my": ["scroll-mt", "scroll-mb"],
      "scroll-p": ["scroll-px", "scroll-py", "scroll-ps", "scroll-pe", "scroll-pbs", "scroll-pbe", "scroll-pt", "scroll-pr", "scroll-pb", "scroll-pl"],
      "scroll-px": ["scroll-pr", "scroll-pl"],
      "scroll-py": ["scroll-pt", "scroll-pb"],
      touch: ["touch-x", "touch-y", "touch-pz"],
      "touch-x": ["touch"],
      "touch-y": ["touch"],
      "touch-pz": ["touch"]
    },
    conflictingClassGroupModifiers: {
      "font-size": ["leading"]
    },
    orderSensitiveModifiers: ["*", "**", "after", "backdrop", "before", "details-content", "file", "first-letter", "first-line", "marker", "placeholder", "selection"]
  };
}, Kt = /* @__PURE__ */ Mt(qt);
function O(...e) {
  return Kt(Ve(e));
}
const Qt = ge(
  [
    "inline-flex items-center justify-center gap-2",
    "font-ui font-medium",
    "transition-colors duration-150",
    "rounded-m",
    "focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-border-focus",
    "disabled:opacity-disabled disabled:pointer-events-none",
    "cursor-pointer"
  ],
  {
    variants: {
      variant: {
        primary: "bg-accent-primary text-accent-on-primary hover:bg-accent-primary-hover active:bg-accent-primary-pressed",
        secondary: "bg-accent-secondary text-accent-on-secondary border border-border-default hover:bg-accent-secondary-hover active:bg-accent-secondary-pressed",
        ghost: "bg-transparent text-accent-primary hover:bg-surface-dim active:bg-surface-extra-dim"
      },
      size: {
        sm: "h-8 px-3 text-body-sm",
        md: "h-10 px-4 text-body-md",
        lg: "h-12 px-6 text-body-lg"
      }
    },
    defaultVariants: {
      variant: "primary",
      size: "md"
    }
  }
), Jt = Ae(
  ({ className: e, variant: n, size: t, icon: o, iconPosition: i = "left", children: s, ...a }, l) => /* @__PURE__ */ m(
    "button",
    {
      ref: l,
      className: O(Qt({ variant: n, size: t }), e),
      ...a,
      children: [
        o && i === "left" && /* @__PURE__ */ r("span", { className: "shrink-0", children: o }),
        s,
        o && i === "right" && /* @__PURE__ */ r("span", { className: "shrink-0", children: o })
      ]
    }
  )
);
Jt.displayName = "Button";
const Zt = ge(
  [
    "w-full rounded-m bg-surface-default",
    "border border-border-default",
    "px-3 py-2 text-body-md font-ui text-text-default",
    "transition-colors duration-150",
    "placeholder:text-text-weakest",
    "hover:border-border-strong",
    "focus:outline-none focus:border-border-focus",
    "disabled:opacity-disabled disabled:cursor-not-allowed"
  ],
  {
    variants: {
      state: {
        default: "",
        error: "border-semantic-danger focus:border-semantic-danger"
      }
    },
    defaultVariants: {
      state: "default"
    }
  }
), Ut = Ae(
  ({ className: e, state: n, label: t, error: o, helperText: i, prefixIcon: s, suffixIcon: a, id: l, ...c }, d) => {
    const p = it(), g = l ?? p;
    return /* @__PURE__ */ m("div", { className: "flex flex-col gap-1", children: [
      t && /* @__PURE__ */ r(
        "label",
        {
          htmlFor: g,
          className: "text-label-md font-medium font-ui text-text-weak",
          children: t
        }
      ),
      /* @__PURE__ */ m("div", { className: "relative flex items-center", children: [
        s && /* @__PURE__ */ r("span", { className: "absolute left-3 text-text-weakest", children: s }),
        /* @__PURE__ */ r(
          "input",
          {
            ref: d,
            id: g,
            className: O(
              Zt({ state: o ? "error" : n }),
              s && "pl-10",
              a && "pr-10",
              e
            ),
            "aria-invalid": !!o,
            "aria-describedby": o ? `${g}-error` : i ? `${g}-helper` : void 0,
            ...c
          }
        ),
        a && /* @__PURE__ */ r("span", { className: "absolute right-3 text-text-weakest", children: a })
      ] }),
      o && /* @__PURE__ */ r("p", { id: `${g}-error`, className: "text-label-sm font-ui text-semantic-danger", children: o }),
      !o && i && /* @__PURE__ */ r("p", { id: `${g}-helper`, className: "text-label-sm font-ui text-text-weakest", children: i })
    ] });
  }
);
Ut.displayName = "Input";
const er = ge("rounded-m font-ui", {
  variants: {
    surface: {
      default: "bg-surface-default",
      dim: "bg-surface-dim",
      "extra-dim": "bg-surface-extra-dim"
    },
    elevation: {
      flat: "",
      raised: "shadow-raised",
      overlay: "shadow-overlay"
    },
    padding: {
      none: "",
      sm: "p-3",
      md: "p-4",
      lg: "p-6"
    }
  },
  defaultVariants: {
    surface: "default",
    elevation: "flat",
    padding: "md"
  }
}), tr = Ae(
  ({ className: e, surface: n, elevation: t, padding: o, children: i, ...s }, a) => /* @__PURE__ */ r(
    "div",
    {
      ref: a,
      className: O(er({ surface: n, elevation: t, padding: o }), e),
      ...s,
      children: i
    }
  )
);
tr.displayName = "Card";
function rr({ items: e, activeId: n, onItemClick: t, header: o, footer: i, className: s }) {
  return /* @__PURE__ */ m(
    "nav",
    {
      className: O(
        "flex flex-col h-full w-20 bg-surface-dim border-r border-border-weak font-ui",
        s
      ),
      children: [
        o && /* @__PURE__ */ r("div", { className: "flex items-center justify-center py-4", children: o }),
        /* @__PURE__ */ r("div", { className: "flex flex-col items-center gap-2 flex-1 py-2", children: e.map((a) => {
          const l = a.id === n;
          return /* @__PURE__ */ m(
            "button",
            {
              onClick: () => t == null ? void 0 : t(a.id),
              className: O(
                "relative flex flex-col items-center justify-center gap-1",
                "w-full py-2 px-1",
                "text-label-sm transition-colors cursor-pointer",
                l ? "text-text-default font-medium" : "text-text-weak hover:text-text-default"
              ),
              children: [
                l && /* @__PURE__ */ r("span", { className: "absolute left-0 top-1/2 -translate-y-1/2 w-1 h-6 bg-accent-primary rounded-pill" }),
                /* @__PURE__ */ r("span", { className: "text-[1.25rem]", children: a.icon }),
                /* @__PURE__ */ r("span", { className: "text-label-sm leading-label truncate max-w-full px-1", children: a.label })
              ]
            },
            a.id
          );
        }) }),
        i && /* @__PURE__ */ r("div", { className: "flex items-center justify-center py-4", children: i })
      ]
    }
  );
}
rr.displayName = "NavRail";
const or = ({ icon: e, label: n, isActive: t, onClick: o }) => {
  const [i, s] = at.useState(!1);
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: o,
      onMouseEnter: () => s(!0),
      onMouseLeave: () => s(!1),
      title: n,
      "aria-label": n,
      "aria-current": t ? "page" : void 0,
      style: {
        width: 48,
        height: 48,
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        background: t ? "var(--ik-color-accent-primary-container)" : i ? "var(--ik-color-surface-dim)" : "transparent",
        borderRadius: "var(--ik-shape-br-xl)",
        cursor: "pointer",
        transition: "background 0.15s ease",
        color: t ? "var(--ik-color-accent-on-primary-container)" : "var(--ik-color-text-weakest)",
        padding: 0
      },
      children: e
    }
  );
}, ke = 0.1, nr = ({
  items: e = [],
  active: n,
  onSelect: t,
  footer: o,
  panelWidth: i,
  panel: s
}) => {
  const a = e.find((y) => y.id === n), l = s !== void 0 ? !!n : !!(a != null && a.panel || a != null && a.panelFooter), c = ie(l), d = c.current !== l;
  c.current = l;
  const p = l ? i !== void 0 ? i : "calc(100% - 52px)" : 0, g = i !== void 0 ? i : "100%", k = d ? `width ${ke}s cubic-bezier(0.25, 0.1, 0.25, 1)` : "none";
  return /* @__PURE__ */ m("div", { style: { display: "flex", height: "100%", width: "100%", flexShrink: 0 }, children: [
    /* @__PURE__ */ m(
      "nav",
      {
        role: "navigation",
        "aria-label": "Main navigation",
        style: {
          width: 52,
          height: "100%",
          background: "var(--ik-color-surface-default)",
          borderRight: "1px solid var(--ik-color-border-weak)",
          display: "flex",
          flexDirection: "column",
          alignItems: "center",
          paddingTop: 8,
          paddingBottom: 12,
          flexShrink: 0,
          boxSizing: "border-box"
        },
        children: [
          /* @__PURE__ */ r(
            "div",
            {
              style: {
                display: "flex",
                flexDirection: "column",
                gap: 2,
                flex: 1,
                alignItems: "center"
              },
              children: e.map((y) => /* @__PURE__ */ r(
                or,
                {
                  icon: y.icon,
                  label: y.label,
                  isActive: n === y.id,
                  onClick: () => t == null ? void 0 : t(y.id)
                },
                y.id
              ))
            }
          ),
          o && /* @__PURE__ */ r("div", { style: { marginTop: "auto", display: "flex", flexDirection: "column", gap: 2 }, children: o })
        ]
      }
    ),
    /* @__PURE__ */ r(
      "aside",
      {
        style: {
          width: p,
          height: "100%",
          background: "var(--ik-color-surface-default)",
          borderRight: l ? "1px solid var(--ik-color-border-weak)" : "none",
          display: "flex",
          flexDirection: "column",
          flexShrink: 0,
          overflow: "hidden",
          boxSizing: "border-box",
          transition: k
        },
        children: /* @__PURE__ */ r(
          "div",
          {
            style: {
              width: g,
              height: "100%",
              display: "flex",
              flexDirection: "column",
              overflow: "hidden"
            },
            children: /* @__PURE__ */ r(
              "div",
              {
                style: {
                  width: g,
                  height: "100%",
                  display: "flex",
                  flexDirection: "column",
                  overflow: "hidden",
                  opacity: l ? 1 : 0,
                  transform: l ? "translateX(0)" : "translateX(-8px)",
                  transition: `opacity ${ke}s ease-out, transform ${ke}s ease-out`,
                  pointerEvents: l ? "auto" : "none"
                },
                children: s !== void 0 ? s : /* @__PURE__ */ m(re, { children: [
                  /* @__PURE__ */ r("div", { style: { flex: 1, overflow: "hidden", display: "flex", flexDirection: "column" }, children: a == null ? void 0 : a.panel }),
                  (a == null ? void 0 : a.panelFooter) && /* @__PURE__ */ r(
                    "div",
                    {
                      style: {
                        padding: "10px 12px",
                        borderTop: "1px solid var(--ik-color-border-weak)",
                        display: "flex",
                        alignItems: "center",
                        gap: 8,
                        flexShrink: 0,
                        background: "var(--ik-color-surface-default)"
                      },
                      children: a.panelFooter
                    }
                  )
                ] })
              }
            )
          }
        )
      }
    )
  ] });
};
function ar(e = 900) {
  const n = () => typeof window < "u" ? window.matchMedia(`(max-width: ${e}px)`).matches : !1, [t, o] = se(n);
  return me(() => {
    if (typeof window > "u") return;
    const i = window.matchMedia(`(max-width: ${e}px)`), s = () => o(i.matches);
    return s(), i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, [e]), t;
}
const ir = ({ icon: e, label: n, isActive: t, badge: o, onClick: i }) => {
  const [s, a] = se(!1);
  return /* @__PURE__ */ r(
    "button",
    {
      onClick: i,
      onTouchStart: () => a(!0),
      onTouchEnd: () => a(!1),
      onMouseDown: () => a(!0),
      onMouseUp: () => a(!1),
      onMouseLeave: () => a(!1),
      "aria-label": n,
      "aria-current": t ? "page" : void 0,
      style: {
        flex: "1 0 auto",
        minWidth: 56,
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        border: "none",
        background: t ? "var(--ik-color-accent-primary-container)" : s ? "var(--ik-color-surface-dim)" : "transparent",
        cursor: "pointer",
        padding: "4px 0 2px",
        WebkitTapHighlightColor: "transparent",
        transform: s ? "scale(0.95)" : "scale(1)",
        transition: "transform 0.08s ease, background 0.08s ease",
        position: "relative",
        touchAction: "manipulation",
        userSelect: "none"
      },
      children: /* @__PURE__ */ m(
        "div",
        {
          style: {
            width: 48,
            height: 48,
            display: "flex",
            alignItems: "center",
            justifyContent: "center",
            borderRadius: "var(--ik-shape-br-xl)",
            background: "transparent",
            color: t ? "var(--ik-color-accent-on-primary-container)" : "var(--ik-color-text-weakest)",
            transition: "color 0.12s ease",
            position: "relative"
          },
          children: [
            e,
            o != null && o > 0 && /* @__PURE__ */ r(
              "span",
              {
                style: {
                  position: "absolute",
                  top: 2,
                  right: 0,
                  minWidth: 16,
                  height: 16,
                  borderRadius: "var(--ik-shape-br-pill, 999px)",
                  background: "var(--ik-color-accent-primary)",
                  color: "var(--ik-color-accent-on-primary)",
                  fontSize: 10,
                  fontWeight: 600,
                  font: "var(--ik-font-default-xs)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  padding: "0 4px",
                  lineHeight: 1,
                  boxSizing: "border-box"
                },
                children: o > 99 ? "99+" : o
              }
            )
          ]
        }
      )
    }
  );
}, sr = 0.1, lr = ({ items: e = [], active: n, onSelect: t, panel: o }) => {
  const i = !!n && o !== void 0;
  return /* @__PURE__ */ m(re, { children: [
    /* @__PURE__ */ r(
      "div",
      {
        style: {
          opacity: i ? 1 : 0,
          pointerEvents: i ? "auto" : "none",
          transition: `opacity ${sr}s ease-out`
        },
        children: o
      }
    ),
    /* @__PURE__ */ r(
      "nav",
      {
        role: "navigation",
        "aria-label": "Main navigation",
        style: {
          width: "100%",
          background: "var(--ik-color-surface-default)",
          borderTop: "1px solid var(--ik-color-border-weak)",
          display: "flex",
          alignItems: "stretch",
          overflowX: "auto",
          overflowY: "hidden",
          flexWrap: "nowrap",
          WebkitOverflowScrolling: "touch",
          scrollbarWidth: "none",
          height: 72,
          paddingBottom: "env(safe-area-inset-bottom, 0px)",
          boxSizing: "content-box",
          flexShrink: 0
        },
        children: e.map((s) => /* @__PURE__ */ r(
          ir,
          {
            icon: s.icon,
            label: s.label,
            badge: s.badge,
            isActive: n === s.id,
            onClick: () => t == null ? void 0 : t(s.id)
          },
          s.id
        ))
      }
    )
  ] });
}, Vr = (e) => {
  var s;
  const n = e.mobile ?? ar(), t = ie(e.active ?? null), o = ie(!1);
  if (me(() => {
    n && e.active && (t.current = e.active);
  }), me(() => {
    var a;
    if (!o.current) {
      o.current = !0;
      return;
    }
    !n && t.current && ((a = e.onSelect) == null || a.call(e, t.current));
  }, [n]), n)
    return /* @__PURE__ */ r(lr, { ...e });
  const i = ((s = e.items) == null ? void 0 : s.map(({ id: a, icon: l, label: c }) => ({ id: a, icon: l, label: c }))) ?? [];
  return /* @__PURE__ */ r(
    nr,
    {
      items: i,
      active: e.active,
      onSelect: e.onSelect,
      footer: e.footer,
      panelWidth: e.panelWidth,
      panel: e.panel
    }
  );
}, cr = ge("flex flex-col font-ui", {
  variants: {
    gap: {
      sm: "gap-1",
      md: "gap-2",
      lg: "gap-4"
    }
  },
  defaultVariants: {
    gap: "md"
  }
});
function dr({
  items: e,
  renderItem: n,
  keyExtractor: t,
  alternating: o = !1,
  gap: i,
  className: s
}) {
  return /* @__PURE__ */ r("div", { className: O(cr({ gap: i }), s), children: e.map((a, l) => /* @__PURE__ */ r(
    "div",
    {
      className: O(
        "rounded-m",
        o && (l % 2 === 0 ? "bg-surface-default" : "bg-surface-dim")
      ),
      children: n(a, l)
    },
    t ? t(a, l) : l
  )) });
}
dr.displayName = "List";
function mr(e, n) {
  return e.name.toLowerCase().includes(n.toLowerCase());
}
function et(e, n, t, o) {
  var i;
  for (const s of e)
    (i = s.children) != null && i.length && (o === "all" ? (n.add(s.id), et(s.children, n, t + 1, o)) : o === "firstLevel" && t < 1 && n.add(s.id));
}
function ur(e, n = /* @__PURE__ */ new Set()) {
  var t;
  for (const o of e)
    (t = o.children) != null && t.length && (n.add(o.id), ur(o.children, n));
  return n;
}
function tt(e, n, t, o) {
  var a;
  let i = 0, s = 0;
  for (const l of e)
    if (s++, (a = l.children) != null && a.length) {
      const c = tt(l.children, n, t, o);
      c === "some" ? (t.add(l.id), i++) : c === "all" && (o.add(l.id), i++);
    } else n.has(l.id) && i++;
  return i === s && s > 0 ? "all" : i > 0 ? "some" : "none";
}
function rt(e, n) {
  var t;
  for (const o of e) {
    if (o.id === n) return o;
    const i = (t = o.children) != null && t.length ? rt(o.children, n) : null;
    if (i) return i;
  }
  return null;
}
function ot(e, n = []) {
  var t;
  if (!((t = e.children) != null && t.length))
    return n.push(e), n;
  for (const o of e.children)
    ot(o, n);
  return n;
}
function Le(e, n = !0) {
  return [...e].sort((t, o) => {
    var a, l;
    const i = t.type === "folder" || !!((a = t.children) != null && a.length), s = o.type === "folder" || !!((l = o.children) != null && l.length);
    return i && !s ? -1 : !i && s ? 1 : n ? t.name.localeCompare(o.name) : 0;
  });
}
function fr(e, n) {
  const [t, o] = se(e), [i, s] = se(e), a = ie(!0);
  return me(() => {
    if (!n) {
      o(e), s(e);
      return;
    }
    if (a.current) {
      a.current = !1;
      return;
    }
    let l = null, c = null;
    return e ? (o(!0), c = requestAnimationFrame(() => {
      c = requestAnimationFrame(() => s(!0));
    })) : (s(!1), l = setTimeout(() => o(!1), 200)), () => {
      l && clearTimeout(l), c && cancelAnimationFrame(c);
    };
  }, [e, n]), { show: t, transitioning: i };
}
const hr = ({ expanded: e }) => /* @__PURE__ */ r("svg", { className: O("h-6 w-6 shrink-0 transition-transform duration-150 sm:h-4 sm:w-4", e && "rotate-90"), viewBox: "0 0 16 16", fill: "none", children: /* @__PURE__ */ r("path", { d: "M6 4l4 4-4 4", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }) }), pr = ({ expanded: e }) => /* @__PURE__ */ r("svg", { className: "h-7 w-7 shrink-0 text-accent-primary sm:h-5 sm:w-5", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: e ? /* @__PURE__ */ r("path", { d: "M6 14l1.45-2.9A2 2 0 019.24 10H20a2 2 0 011.94 2.5l-1.55 6a2 2 0 01-1.94 1.5H4a2 2 0 01-2-2V5a2 2 0 012-2h3.9a2 2 0 011.69.9l.81 1.2a2 2 0 001.67.9H18a2 2 0 012 2v2" }) : /* @__PURE__ */ r("path", { d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" }) }), br = () => /* @__PURE__ */ m("svg", { className: "h-5 w-5 shrink-0 text-text-weakest sm:h-4 sm:w-4", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ r("path", { d: "M13 2H6a2 2 0 00-2 2v16a2 2 0 002 2h12a2 2 0 002-2V9z" }),
  /* @__PURE__ */ r("path", { d: "M13 2v7h7" })
] }), xr = () => /* @__PURE__ */ m("svg", { className: "h-5 w-5 shrink-0 text-text-weak sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.5", children: [
  /* @__PURE__ */ r("path", { d: "M6.5 9.5a3 3 0 004.243 0l2-2a3 3 0 00-4.243-4.243L7.25 4.5", strokeLinecap: "round" }),
  /* @__PURE__ */ r("path", { d: "M9.5 6.5a3 3 0 00-4.243 0l-2 2a3 3 0 004.243 4.243L8.75 11.5", strokeLinecap: "round" })
] }), gr = ({ checked: e, indeterminate: n }) => /* @__PURE__ */ m("svg", { className: "block h-6 w-6 shrink-0 cursor-pointer sm:h-4 sm:w-4", viewBox: "0 0 16 16", children: [
  /* @__PURE__ */ r(
    "rect",
    {
      x: "1",
      y: "1",
      width: "14",
      height: "14",
      rx: "2",
      className: O(e || n ? "fill-accent-primary stroke-accent-primary" : "fill-none stroke-border-default"),
      strokeWidth: "1.5"
    }
  ),
  e && !n && /* @__PURE__ */ r("path", { d: "M4 8l2.5 2.5L12 5", stroke: "white", strokeWidth: "2", strokeLinecap: "round", strokeLinejoin: "round", fill: "none" }),
  n && /* @__PURE__ */ r("line", { x1: "4", y1: "8", x2: "12", y2: "8", stroke: "white", strokeWidth: "2", strokeLinecap: "round" })
] }), vr = () => /* @__PURE__ */ m("svg", { className: "h-5 w-5 shrink-0 animate-spin text-accent-primary sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", children: [
  /* @__PURE__ */ r("circle", { cx: "8", cy: "8", r: "6", stroke: "currentColor", strokeWidth: "2", opacity: "0.25" }),
  /* @__PURE__ */ r("path", { d: "M14 8a6 6 0 00-6-6", stroke: "currentColor", strokeWidth: "2", strokeLinecap: "round" })
] }), yr = () => /* @__PURE__ */ m(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-blue-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r("rect", { x: "2", y: "2", width: "12", height: "12", rx: "1.5" }),
      /* @__PURE__ */ r("line", { x1: "2", y1: "6", x2: "14", y2: "6" }),
      /* @__PURE__ */ r("line", { x1: "6", y1: "6", x2: "6", y2: "14" })
    ]
  }
), wr = {
  dwg: { label: "DWG", bodyFill: "#E8724A", foldFill: "#F4B8A3", textFill: "#5C1A00" },
  dxf: { label: "DXF", bodyFill: "#F5A623", foldFill: "#FCDFA6", textFill: "#5C3D00" },
  ifc: { label: "IFC", bodyFill: "#89C4E9", foldFill: "#D3EAF8", textFill: "#00357F" },
  xml: { label: "XML", bodyFill: "#D4A04A", foldFill: "#F0DCA0", textFill: "#5C3D00" },
  gt: { label: "GT", bodyFill: "#967ADC", foldFill: "#D1C4F1", textFill: "#2E1A5E" },
  shp: { label: "SHP", bodyFill: "#48CFAD", foldFill: "#B5EDE0", textFill: "#0A4A3A" },
  pdf: { label: "PDF", bodyFill: "#DA4453", foldFill: "#F0B3B8", textFill: "#4A0A12" }
}, kr = () => /* @__PURE__ */ m("svg", { className: "h-5 w-5 shrink-0 text-semantic-danger sm:h-4 sm:w-4", viewBox: "0 0 16 16", fill: "none", stroke: "currentColor", strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round", children: [
  /* @__PURE__ */ r("circle", { cx: "8", cy: "8", r: "6" }),
  /* @__PURE__ */ r("line", { x1: "8", y1: "5", x2: "8", y2: "9" }),
  /* @__PURE__ */ r("circle", { cx: "8", cy: "11.5", r: "0.75", fill: "currentColor", stroke: "none" })
] }), Nr = ({ config: e }) => /* @__PURE__ */ m("svg", { className: "h-7 w-7 shrink-0 sm:h-5 sm:w-5", viewBox: "0 0 16 16", fill: "none", children: [
  /* @__PURE__ */ r("path", { d: "M4 1.5A1.5 1.5 0 015.5 0h4.586a1.5 1.5 0 011.06.44l2.354 2.353a1.5 1.5 0 01.44 1.061V14.5A1.5 1.5 0 0112.5 16h-7A1.5 1.5 0 014 14.5v-13z", fill: "none", stroke: e.bodyFill, strokeWidth: "1.5", strokeLinejoin: "round" }),
  /* @__PURE__ */ r("path", { d: "M10.086 0.146V3.5a1 1 0 001 1H14.44", fill: "none", stroke: e.foldFill, strokeWidth: "1.5", strokeLinecap: "round", strokeLinejoin: "round" }),
  /* @__PURE__ */ r(
    "rect",
    {
      x: "1.5",
      y: "8",
      width: "13",
      height: "7",
      rx: "1",
      fill: "white",
      stroke: e.textFill,
      strokeWidth: "0.6"
    }
  ),
  /* @__PURE__ */ r(
    "text",
    {
      x: "8",
      y: "11.5",
      textAnchor: "middle",
      dominantBaseline: "middle",
      fontFamily: "Inter Tight, Arial, sans-serif",
      fontSize: e.label.length <= 2 ? "5.8" : "4.8",
      fontWeight: "700",
      letterSpacing: "0.2",
      fill: e.textFill,
      children: e.label
    }
  )
] }), Cr = () => /* @__PURE__ */ m(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-green-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r("path", { d: "M1 13l4-8 3 5 2.5-3L15 13H1z" }),
      /* @__PURE__ */ r("path", { d: "M5 5l3 5" }),
      /* @__PURE__ */ r("path", { d: "M10.5 7L8 10" })
    ]
  }
), Ar = () => /* @__PURE__ */ m(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-yellow-800 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r("path", { d: "M2 5h5v6h5" }),
      /* @__PURE__ */ r("circle", { cx: "7", cy: "8", r: "1.5" }),
      /* @__PURE__ */ r("line", { x1: "12", y1: "8", x2: "14", y2: "8" }),
      /* @__PURE__ */ r("line", { x1: "12", y1: "11", x2: "14", y2: "11" }),
      /* @__PURE__ */ r("rect", { x: "11.5", y: "7", width: "3", height: "5", rx: "0.5" })
    ]
  }
), zr = () => /* @__PURE__ */ m(
  "svg",
  {
    className: "h-5 w-5 shrink-0 text-red-600 sm:h-4 sm:w-4",
    viewBox: "0 0 16 16",
    fill: "none",
    stroke: "currentColor",
    strokeWidth: "1.4",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    children: [
      /* @__PURE__ */ r("path", { d: "M2 13C4 9 6 4 8 4s4 5 6 9" }),
      /* @__PURE__ */ r("line", { x1: "5", y1: "8.5", x2: "11", y2: "8.5", strokeDasharray: "1.5 1.5" })
    ]
  }
), Mr = {
  drawing: yr,
  surface: Cr,
  pipe: Ar,
  alignment: zr
}, Lr = {
  dwg: "drawing",
  dxf: "drawing"
};
function nt(e) {
  const n = e.lastIndexOf(".");
  if (n !== -1)
    return e.slice(n + 1).toLowerCase();
}
function Ir(e) {
  if (e.layerType) return e.layerType;
  const n = nt(e.name);
  if (n)
    return Lr[n];
}
function Fr(e, n) {
  var o;
  if (e.icon) return e.icon;
  const t = e.type ?? ((o = e.children) != null && o.length ? "folder" : "file");
  if (t === "file") {
    const i = nt(e.name);
    if (i) {
      const a = wr[i];
      if (a) return /* @__PURE__ */ r(Nr, { config: a });
    }
    const s = Ir(e);
    if (s) {
      const a = Mr[s];
      if (a) return /* @__PURE__ */ r(a, {});
    }
  }
  switch (t) {
    case "folder":
      return /* @__PURE__ */ r(pr, { expanded: n });
    case "link":
      return /* @__PURE__ */ r(xr, {});
    default:
      return /* @__PURE__ */ r(br, {});
  }
}
function Ce(e, n, t) {
  var o;
  return t(e, n) ? !0 : ((o = e.children) == null ? void 0 : o.some((i) => Ce(i, n, t))) ?? !1;
}
function ve({
  node: e,
  level: n,
  selectedId: t,
  onSelect: o,
  onDoubleClick: i,
  onContextMenu: s,
  checkable: a,
  checkedIds: l,
  indeterminateIds: c,
  onToggleCheck: d,
  loadingIds: p,
  expandedIds: g,
  onToggleExpand: k,
  filterText: y,
  matchesFilter: I,
  renderLabel: z,
  hideEmptyFolders: w,
  animated: F = !1
}) {
  var P;
  const S = !!((P = e.children) != null && P.length), j = g.has(e.id), { show: G, transitioning: H } = fr(j, F), M = t != null && e.id == t, E = l.has(e.id) || c.has(e.id), h = c.has(e.id), R = p.has(e.id), A = ie(null), V = ie(!1), $ = Q(() => y ? Ce(e, y, I) : !0, [e, y, I]), J = Q(() => Le(e.children ?? []), [e.children]);
  return !$ || w && S && e.children.filter((B) => !y || Ce(B, y, I)).length === 0 ? null : /* @__PURE__ */ m("div", { role: "treeitem", "aria-expanded": S ? j : void 0, children: [
    /* @__PURE__ */ m(
      "div",
      {
        className: O(
          "relative flex cursor-pointer select-none items-center gap-1.5 overflow-hidden rounded-s px-2 py-1 transition-colors duration-100",
          "hover:bg-surface-dim active:bg-surface-extra-dim",
          "max-sm:gap-3 max-sm:rounded-m max-sm:px-4 max-sm:py-3",
          M && "bg-surface-dim font-medium text-text-default"
        ),
        style: {
          paddingLeft: `calc(${n} * 16px + 8px)`
        },
        onClick: (N) => {
          if (N.shiftKey && a && S) {
            d == null || d(e, { deep: !0 });
            return;
          }
          S && k(e.id), o == null || o(e);
        },
        onDoubleClick: () => i == null ? void 0 : i(e),
        onContextMenu: (N) => {
          s && (N.preventDefault(), N.stopPropagation(), s(e, { x: N.pageX, y: N.pageY }));
        },
        children: [
          n > 0 && /* @__PURE__ */ m(re, { children: [
            /* @__PURE__ */ r(
              "span",
              {
                className: "pointer-events-none absolute bg-accent-primary-container",
                style: {
                  left: `${n * 16 + 2}px`,
                  top: "-8px",
                  bottom: "50%",
                  width: "1.5px"
                }
              }
            ),
            /* @__PURE__ */ r(
              "span",
              {
                className: "pointer-events-none absolute bg-accent-primary-container",
                style: {
                  left: `${n * 16 + 2}px`,
                  top: "50%",
                  width: "6px",
                  height: "1.5px"
                }
              }
            )
          ] }),
          M && /* @__PURE__ */ r("span", { className: "absolute inset-y-1.5 left-0 w-1 rounded-pill bg-accent-primary" }),
          /* @__PURE__ */ r(
            "span",
            {
              className: O("relative z-10 flex h-6 w-6 shrink-0 items-center justify-center sm:h-4 sm:w-4", !S && "invisible"),
              onClick: (N) => {
                N.stopPropagation(), S && k(e.id);
              },
              children: S && /* @__PURE__ */ r(hr, { expanded: j })
            }
          ),
          a && /* @__PURE__ */ r(
            "span",
            {
              className: "relative z-10 flex shrink-0 items-center",
              onPointerDown: (N) => {
                N.stopPropagation(), !(!S || !d) && (V.current = !1, A.current = setTimeout(() => {
                  V.current = !0, d(e, { deep: !0 });
                }, 300));
              },
              onPointerUp: (N) => {
                N.stopPropagation(), A.current && (clearTimeout(A.current), A.current = null);
              },
              onPointerLeave: () => {
                A.current && (clearTimeout(A.current), A.current = null);
              },
              onClick: (N) => {
                if (N.stopPropagation(), V.current) {
                  V.current = !1;
                  return;
                }
                d == null || d(e, N.shiftKey ? { deep: !0 } : void 0);
              },
              children: /* @__PURE__ */ r(gr, { checked: E, indeterminate: h })
            }
          ),
          R ? /* @__PURE__ */ r(vr, {}) : Fr(e, j),
          /* @__PURE__ */ r("span", { className: O("min-w-0 flex-1 truncate select-none text-body-md leading-body", R && "opacity-loading"), children: z ? z(e) : e.name }),
          e.secondaryIcon && /* @__PURE__ */ r("span", { className: "shrink-0 text-text-weakest", children: e.secondaryIcon }),
          e.error && /* @__PURE__ */ r("span", { className: "shrink-0", title: e.error, children: /* @__PURE__ */ r(kr, {}) })
        ]
      }
    ),
    S && (F ? G : j) && /* @__PURE__ */ r(
      "div",
      {
        role: "group",
        className: O(
          F && "grid transition-[grid-template-rows] duration-200 ease-out",
          F && (H ? "grid-rows-[1fr]" : "grid-rows-[0fr]")
        ),
        children: /* @__PURE__ */ r("div", { className: O(F && "overflow-hidden"), children: J.map((N) => /* @__PURE__ */ r(
          ve,
          {
            node: N,
            level: n + 1,
            selectedId: t,
            onSelect: o,
            onDoubleClick: i,
            onContextMenu: s,
            checkable: a,
            checkedIds: l,
            indeterminateIds: c,
            onToggleCheck: d,
            loadingIds: p,
            expandedIds: g,
            onToggleExpand: k,
            filterText: y,
            matchesFilter: I,
            renderLabel: z,
            hideEmptyFolders: w,
            animated: F
          },
          N.id
        )) })
      }
    )
  ] });
}
ve.displayName = "TreeNodeRow";
function Sr({
  nodes: e,
  selectedId: n,
  onNodeSelected: t,
  onDoubleClick: o,
  onContextMenu: i,
  checkable: s,
  checkedIds: a,
  indeterminateIds: l,
  loadingIds: c,
  expandedIds: d,
  onToggleExpand: p,
  onToggleCheck: g,
  filterText: k,
  matchesFilter: y,
  renderLabel: I,
  hideEmptyFolders: z,
  sortChildren: w
}) {
  const F = Q(() => Le(e, w), [e, w]);
  return /* @__PURE__ */ r("div", { className: "flex min-h-0 flex-1 flex-col px-0 pb-1", children: /* @__PURE__ */ r("div", { role: "tree", className: "min-h-0 flex-1 overflow-auto", children: F.map((S) => /* @__PURE__ */ r(
    ve,
    {
      node: S,
      level: 0,
      selectedId: n,
      onSelect: t,
      onDoubleClick: o,
      onContextMenu: i,
      checkable: s,
      checkedIds: a,
      indeterminateIds: l,
      onToggleCheck: g,
      loadingIds: c,
      expandedIds: d,
      onToggleExpand: p,
      filterText: k,
      matchesFilter: y,
      renderLabel: I,
      hideEmptyFolders: z,
      animated: !0
    },
    S.id
  )) }) });
}
function jr({
  nodes: e,
  selectedId: n,
  onNodeSelected: t,
  onDoubleClick: o,
  onContextMenu: i,
  checkable: s,
  checkedIds: a,
  indeterminateIds: l,
  loadingIds: c,
  expandedIds: d,
  onToggleExpand: p,
  onToggleCheck: g,
  filterText: k,
  matchesFilter: y,
  renderLabel: I,
  hideEmptyFolders: z,
  selectOnNavigate: w = !1
}) {
  const [F, S] = se([]), j = F.length ? rt(e, F[F.length - 1]) : null, G = Le((j == null ? void 0 : j.children) ?? e), H = Q(() => /* @__PURE__ */ new Set(), []), M = ae(
    (A) => {
      d.has(A.id) || p(A.id), S((V) => [...V, A.id]);
    },
    [d, p]
  ), E = ae(
    (A) => {
      var V;
      (V = A.children) != null && V.length && (M(A), !w) || t == null || t(A);
    },
    [M, t, w]
  ), h = ae((A) => {
  }, []), R = ae(() => {
    S((A) => A.slice(0, -1));
  }, []);
  return /* @__PURE__ */ m(re, { children: [
    j && /* @__PURE__ */ m("div", { style: { display: "flex", alignItems: "center", justifyContent: "flex-start", width: "100%", alignSelf: "flex-start", textAlign: "left" }, className: "border-b border-border-weak bg-surface-dim px-4 py-3", children: [
      /* @__PURE__ */ r(
        "button",
        {
          type: "button",
          onClick: R,
          "aria-label": "Go back",
          style: { marginRight: 12, flexShrink: 0 },
          className: "flex h-[48px] w-[48px] cursor-pointer items-center justify-center rounded-m border-0 bg-accent-primary text-text-white",
          children: /* @__PURE__ */ r("svg", { className: "h-6 w-6", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "3", strokeLinecap: "round", strokeLinejoin: "round", children: /* @__PURE__ */ r("path", { d: "M15 18l-6-6 6-6" }) })
        }
      ),
      /* @__PURE__ */ m(
        "button",
        {
          type: "button",
          style: { display: "flex", alignItems: "center", justifyContent: "flex-start", gap: 8, minWidth: 0, flex: "1 1 auto", textAlign: "left" },
          className: "border-0 bg-transparent",
          onClick: () => t == null ? void 0 : t(j),
          children: [
            /* @__PURE__ */ r("svg", { className: "h-8 w-8 shrink-0 text-accent-primary", viewBox: "0 0 24 24", fill: "none", stroke: "currentColor", strokeWidth: "1.8", strokeLinecap: "round", strokeLinejoin: "round", children: /* @__PURE__ */ r("path", { d: "M22 19a2 2 0 01-2 2H4a2 2 0 01-2-2V5a2 2 0 012-2h5l2 3h9a2 2 0 012 2z" }) }),
            /* @__PURE__ */ r("span", { className: "truncate text-title-md font-medium text-text-default", children: I ? I(j) : j.name })
          ]
        }
      )
    ] }),
    /* @__PURE__ */ r("div", { className: "overflow-auto px-0 pb-1", role: "tree", children: G.map((A) => /* @__PURE__ */ r(
      ve,
      {
        node: A,
        level: 0,
        selectedId: n,
        onSelect: E,
        onDoubleClick: o,
        onContextMenu: i,
        checkable: s,
        checkedIds: a,
        indeterminateIds: l,
        onToggleCheck: g,
        loadingIds: c,
        expandedIds: H,
        onToggleExpand: h,
        filterText: k,
        matchesFilter: y,
        renderLabel: I,
        hideEmptyFolders: z
      },
      A.id
    )) })
  ] });
}
function Rr(e = 639) {
  const n = () => typeof window < "u" ? window.matchMedia(`(max-width: ${e}px)`).matches : !1, [t, o] = se(n);
  return me(() => {
    if (typeof window > "u") return;
    const i = window.matchMedia(`(max-width: ${e}px)`), s = () => o(i.matches);
    return s(), i.addEventListener("change", s), () => i.removeEventListener("change", s);
  }, [e]), t;
}
function Tr({
  nodes: e,
  treeData: n,
  showRoot: t = !0,
  selectedId: o,
  onNodeSelected: i,
  onDoubleClick: s,
  onContextMenu: a,
  checkable: l = !1,
  checkedIds: c,
  onNodeChecked: d,
  onNodeUnchecked: p,
  loadingIds: g,
  expandOnStart: k = "firstLevel",
  expandedIds: y,
  onExpandedIdsChange: I,
  filterText: z = "",
  matchesFilter: w = mr,
  renderLabel: F,
  hideEmptyFolders: S = !1,
  sortChildren: j = !0,
  selectOnNavigate: G = !1,
  className: H,
  propagateCheckbox: M
}) {
  const E = n ?? e ?? [], h = y !== void 0, [R, A] = se(() => {
    const C = /* @__PURE__ */ new Set();
    return et(E, C, 0, k), C;
  }), V = Q(() => h ? new Set(y) : R, [h, y, R]), $ = Q(() => new Set(c ?? []), [c]), J = Q(() => new Set(g ?? []), [g]), { indeterminateSet: P, fullyCheckedSet: N } = Q(() => {
    const C = /* @__PURE__ */ new Set(), X = /* @__PURE__ */ new Set();
    return tt(E, $, C, X), { indeterminateSet: C, fullyCheckedSet: X };
  }, [E, $]), B = Q(() => {
    const C = new Set($);
    return N.forEach((X) => C.add(X)), C;
  }, [$, N]), Y = ae(
    (C) => {
      const X = (Z) => {
        const T = new Set(Z);
        return T.has(C) ? T.delete(C) : T.add(C), T;
      };
      if (h && I !== void 0) {
        I(Array.from(X(new Set(y))));
        return;
      }
      A((Z) => X(Z));
    },
    [h, y, I]
  ), x = ae(
    (C, X) => {
      var T, _;
      const Z = B.has(C.id) || P.has(C.id);
      if (X != null && X.deep && ((T = C.children) != null && T.length)) {
        const K = ot(C), q = K.every((L) => $.has(L.id));
        K.forEach((L) => {
          q ? p == null || p(L) : $.has(L.id) || d == null || d(L);
        });
        return;
      }
      if ((_ = C.children) != null && _.length && M !== !1) {
        const K = C.children.filter((q) => {
          var L;
          return !((L = q.children) != null && L.length);
        });
        Z ? K.forEach((q) => {
          $.has(q.id) && (p == null || p(q));
        }) : K.forEach((q) => {
          $.has(q.id) || d == null || d(q);
        });
        return;
      }
      B.has(C.id) ? p == null || p(C) : d == null || d(C);
    },
    [$, P, B, d, p, M]
  ), W = ae(
    (C) => {
      i == null || i(C);
    },
    [i]
  ), b = Rr(), ce = Q(() => {
    var C;
    return t || E.length !== 1 ? E : ((C = E[0]) == null ? void 0 : C.children) ?? [];
  }, [t, E]);
  return /* @__PURE__ */ r("div", { className: O("flex h-full min-h-[200px] min-w-[200px] flex-col overflow-hidden rounded-l bg-surface-default font-ui text-body-md leading-body text-text-default", H), children: b ? /* @__PURE__ */ r(
    jr,
    {
      nodes: ce,
      selectedId: o,
      onNodeSelected: i,
      onDoubleClick: s,
      onContextMenu: a,
      checkable: l,
      checkedIds: B,
      indeterminateIds: P,
      loadingIds: J,
      expandedIds: V,
      onToggleExpand: Y,
      onToggleCheck: x,
      filterText: z,
      matchesFilter: w,
      renderLabel: F,
      hideEmptyFolders: S,
      selectOnNavigate: G
    }
  ) : /* @__PURE__ */ r(
    Sr,
    {
      nodes: ce,
      selectedId: o,
      onNodeSelected: W,
      onDoubleClick: s,
      onContextMenu: a,
      checkable: l,
      checkedIds: B,
      indeterminateIds: P,
      loadingIds: J,
      expandedIds: V,
      onToggleExpand: Y,
      onToggleCheck: x,
      filterText: z,
      matchesFilter: w,
      renderLabel: F,
      hideEmptyFolders: S,
      sortChildren: j
    }
  ) });
}
Tr.displayName = "Tree";
const Br = ({ size: e = 24 }) => {
  const n = "M12 1 C12 6 17 12 23 12 C17 12 12 18 12 23 C12 18 7 12 1 12 C7 12 12 6 12 1 Z";
  return /* @__PURE__ */ m("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "-2 -2 28 28", width: e, height: e, fill: "none", style: { overflow: "visible" }, children: [
    /* @__PURE__ */ r("path", { fill: "#2196f3", stroke: "#2196f3", strokeWidth: 1.5, strokeLinejoin: "round", d: n }),
    /* @__PURE__ */ r("path", { fill: "#2196f3", stroke: "#2196f3", strokeWidth: 1.5, strokeLinejoin: "round", opacity: 0.95, transform: "translate(14, -3.5) scale(0.42)", d: n })
  ] });
};
Br.displayName = "AISparkleIcon";
const Er = ({
  suggestion: e,
  onRemove: n,
  uploadProgress: t,
  isUploading: o,
  isSkipped: i,
  isPreSkipped: s,
  isAccepted: a,
  onToggleAccepted: l,
  strings: c
}) => {
  const d = o && t !== void 0 && t < 100, p = t === 100;
  return /* @__PURE__ */ r(
    "div",
    {
      className: `rounded-xl border p-3 transition-colors ${s ? "bg-semantic-warning-container border-yellow-200" : p && !i ? "bg-semantic-success-container border-green-200" : a ? "bg-surface-default border-blue-300" : "bg-surface-default border-border-weak"}`,
      children: /* @__PURE__ */ m("div", { className: "flex items-start gap-2.5", children: [
        l && /* @__PURE__ */ r(
          "input",
          {
            type: "checkbox",
            checked: a && !s,
            onChange: l,
            disabled: o || s,
            title: c.selectForRefineTitle,
            className: "w-4 h-4 mt-0.5 accent-semantic-info cursor-pointer disabled:cursor-not-allowed shrink-0"
          }
        ),
        /* @__PURE__ */ r("i", { className: "iki iki-files text-[1.2em] opacity-50 mt-0.5 shrink-0" }),
        /* @__PURE__ */ m("div", { className: "flex-1 min-w-0", children: [
          /* @__PURE__ */ r("div", { className: `text-body-sm font-medium truncate ${s ? "opacity-disabled" : ""}`, title: e.filename, children: e.filename }),
          e.folder_path && /* @__PURE__ */ m("div", { className: "mt-0.5 flex items-center gap-1 font-mono text-label-sm text-text-weakest", children: [
            /* @__PURE__ */ r("i", { className: "iki iki-folder text-semantic-info text-[0.9em]" }),
            e.folder_path
          ] }),
          s && !i && /* @__PURE__ */ m("div", { className: "mt-2 px-2.5 py-2 bg-surface-default/70 border border-yellow-200 rounded-l flex items-start gap-2", children: [
            /* @__PURE__ */ r("i", { className: "iki iki-warning text-semantic-warning shrink-0 mt-px" }),
            /* @__PURE__ */ m("span", { className: "text-body-sm text-text-weak", children: [
              /* @__PURE__ */ r("strong", { className: "text-semantic-on-warning-container", children: c.fileExistsTitle }),
              " — ",
              c.fileExistsDesc
            ] })
          ] }),
          d && /* @__PURE__ */ m("div", { className: "mt-2", children: [
            /* @__PURE__ */ r("div", { className: "text-label-sm text-text-weakest mb-1", children: c.uploadingStatus(t) }),
            /* @__PURE__ */ r("div", { className: "w-full h-1 bg-surface-extra-dim rounded-pill overflow-hidden", children: /* @__PURE__ */ r("div", { className: "h-full bg-semantic-info transition-[width] duration-300 ease-in-out", style: { width: `${t}%` } }) })
          ] }),
          p && !i && /* @__PURE__ */ m("div", { className: "text-label-sm text-semantic-success mt-1 flex items-center gap-1", children: [
            /* @__PURE__ */ r("i", { className: "iki iki-check" }),
            " ",
            c.uploadedStatus
          ] }),
          i && /* @__PURE__ */ r("div", { className: "text-label-sm text-semantic-warning mt-1", children: c.skippedStatus })
        ] }),
        !o && /* @__PURE__ */ r(
          "button",
          {
            className: "text-text-weakest hover:text-semantic-danger hover:bg-surface-dim p-1 rounded-l shrink-0 text-[1.2em] leading-none font-bold",
            onClick: () => n(e.filename),
            title: c.removeTitle,
            children: "×"
          }
        )
      ] })
    }
  );
}, $r = ({
  step: e,
  isMinimized: n,
  onToggleMinimized: t,
  onClose: o,
  error: i,
  isProcessing: s,
  isUploading: a,
  strings: l,
  selectedFiles: c,
  onFilesSelected: d,
  onRemoveFile: p,
  onAnalyze: g,
  suggestions: k,
  preSkippedFiles: y,
  skippedFiles: I,
  uploadProgress: z,
  selectedForRefine: w,
  onToggleSelectedForRefine: F,
  onRemoveFromResults: S,
  refinePrompt: j,
  onRefinePromptChange: G,
  onRefine: H,
  uploadableSuggestions: M,
  onBackToSelect: E,
  onContinueToConfirm: h,
  skippedCount: R,
  overallProgress: A,
  folderGroups: V,
  onUploadAll: $,
  onBackToResults: J
}) => {
  const P = ie(null), N = (x) => {
    const W = Array.from(x.target.files || []);
    W.length > 0 && d(W), x.target.value = "";
  }, B = (x) => {
    x.preventDefault(), x.stopPropagation();
  }, Y = (x) => {
    x.preventDefault(), x.stopPropagation();
    const W = Array.from(x.dataTransfer.files || []);
    W.length > 0 && d(W);
  };
  return /* @__PURE__ */ m(
    "div",
    {
      className: `bg-surface-default overflow-hidden transition-all duration-300 ease-in-out ${n ? "w-full rounded-xl shadow-[0_4px_16px_rgba(0,0,0,.15)]" : "rounded-xl shadow-[0_12px_40px_rgba(15,17,28,.18)] max-h-[85vh] flex flex-col"}`,
      children: [
        /* @__PURE__ */ m("div", { className: `flex items-center gap-3 border-b border-border-weak bg-surface-default ${n ? "librarian-header py-3 px-4 cursor-move" : "px-5 py-4"}`, children: [
          /* @__PURE__ */ r("i", { className: "iki iki-ai text-[1.6em] opacity-60 shrink-0" }),
          /* @__PURE__ */ m("div", { className: "flex-1", children: [
            /* @__PURE__ */ r("div", { className: "text-body-lg font-semibold leading-tight", children: l.title }),
            /* @__PURE__ */ r("div", { className: "text-label-sm text-text-weakest leading-tight", children: l.stepSubtitles[e] })
          ] }),
          /* @__PURE__ */ r(
            "i",
            {
              className: `iki ${n ? "iki-chevron-up" : "iki-chevron-down"} clickable opacity-50 hover:opacity-100 hover:bg-neutral-1000/5 py-1 px-2 rounded-m text-[1em]`,
              onClick: (x) => {
                x.stopPropagation(), t();
              },
              title: n ? l.expandTitle : l.minimizeTitle
            }
          ),
          /* @__PURE__ */ r(
            "i",
            {
              className: "iki iki-close clickable opacity-50 hover:opacity-100 hover:bg-neutral-1000/5 py-1 px-2 rounded-m text-[1em]",
              onClick: (x) => {
                x.stopPropagation(), o();
              },
              title: l.closeTitle
            }
          )
        ] }),
        !n && /* @__PURE__ */ m(re, { children: [
          /* @__PURE__ */ m("div", { className: `flex-1 min-h-0 overflow-y-auto p-5 bg-surface-dim ${s ? "overlay-loading" : ""}`, children: [
            i && /* @__PURE__ */ r("div", { className: "mb-4 padded alert alert-danger", children: i }),
            e === "select" && /* @__PURE__ */ m("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ m(
                "div",
                {
                  className: "rounded-xl border-2 border-dashed border-border-default bg-surface-default hover:bg-surface-dim transition-colors cursor-pointer text-center px-6 py-8",
                  onDragOver: B,
                  onDrop: Y,
                  onClick: () => {
                    var x;
                    return (x = P.current) == null ? void 0 : x.click();
                  },
                  children: [
                    /* @__PURE__ */ r("input", { ref: P, type: "file", multiple: !0, className: "hidden", onChange: N }),
                    /* @__PURE__ */ r("div", { className: "w-11 h-11 mx-auto mb-3 rounded-xl bg-surface-extra-dim flex items-center justify-center", children: /* @__PURE__ */ r("i", { className: "iki iki-upload text-[1.4em] opacity-60" }) }),
                    /* @__PURE__ */ r("div", { className: "text-body-md font-semibold mb-1", children: l.dragAndDrop }),
                    /* @__PURE__ */ r("div", { className: "text-body-sm text-text-weakest mb-3", children: l.orClickToBrowse }),
                    /* @__PURE__ */ r(
                      "button",
                      {
                        className: "bg-surface-default border border-border-default rounded-l px-4 py-1.5 text-body-sm font-medium hover:bg-surface-dim",
                        onClick: (x) => {
                          var W;
                          x.stopPropagation(), (W = P.current) == null || W.click();
                        },
                        children: l.browseFiles
                      }
                    )
                  ]
                }
              ),
              c.length > 0 && /* @__PURE__ */ m("div", { className: "flex-column gap-1.5", children: [
                /* @__PURE__ */ r("div", { className: "text-body-sm font-semibold text-text-weak", children: l.filesAdded(c.length) }),
                /* @__PURE__ */ r("div", { className: "flex-column gap-1.5 max-h-48 overflow-y-auto", children: c.map((x, W) => /* @__PURE__ */ m(
                  "div",
                  {
                    className: "flex items-center gap-2.5 px-3 py-2 rounded-l border border-border-weak bg-surface-default hover:border-border-default transition-colors",
                    children: [
                      /* @__PURE__ */ r("i", { className: "iki iki-files text-[1.1em] opacity-50 shrink-0" }),
                      /* @__PURE__ */ r("span", { className: "flex-1 text-body-sm font-medium truncate", children: x.name }),
                      /* @__PURE__ */ r(
                        "button",
                        {
                          className: "text-text-weakest hover:text-semantic-danger hover:bg-surface-dim p-1 rounded-m shrink-0 text-[1.2em] leading-none font-bold",
                          onClick: () => p(W),
                          title: l.resultItem.removeTitle,
                          children: "×"
                        }
                      )
                    ]
                  },
                  W
                )) })
              ] })
            ] }),
            e === "results" && /* @__PURE__ */ m("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ r("div", { className: "text-body-sm text-text-weakest italic", children: l.resultsInstructions }),
              /* @__PURE__ */ r("div", { className: "flex-column gap-2 max-h-64 overflow-y-auto", children: k.map((x) => /* @__PURE__ */ r(
                Er,
                {
                  suggestion: x,
                  onRemove: S,
                  uploadProgress: z[x.filename],
                  isUploading: a,
                  isSkipped: I.has(x.filename),
                  isPreSkipped: y.has(x.filename),
                  isAccepted: w.has(x.filename),
                  onToggleAccepted: () => F(x.filename),
                  strings: l.resultItem
                },
                x.filename
              )) }),
              /* @__PURE__ */ m("div", { className: "rounded-xl border border-border-weak bg-surface-default p-3.5", children: [
                /* @__PURE__ */ m("div", { className: "flex items-center gap-2 mb-2", children: [
                  /* @__PURE__ */ r("i", { className: "iki iki-chat text-[1.1em] opacity-50" }),
                  /* @__PURE__ */ r("span", { className: "text-body-sm font-semibold", children: l.refineTitle }),
                  /* @__PURE__ */ r("span", { className: "text-label-sm text-text-weakest", children: l.refineHint })
                ] }),
                /* @__PURE__ */ r(
                  "textarea",
                  {
                    placeholder: l.refinePlaceholder,
                    value: j,
                    onChange: (x) => G(x.currentTarget.value),
                    rows: 2,
                    className: "w-full border border-border-default rounded-l px-2.5 py-2 text-body-sm resize-y outline-none focus:border-border-focus"
                  }
                ),
                /* @__PURE__ */ r("div", { className: "flex justify-end mt-2", children: /* @__PURE__ */ r(
                  "button",
                  {
                    className: `border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium ${w.size === 0 || !j.trim() || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-surface-dim"}`,
                    onClick: H,
                    disabled: w.size === 0 || !j.trim() || s,
                    children: s ? l.refining : l.refineButton
                  }
                ) })
              ] })
            ] }),
            e === "confirm" && /* @__PURE__ */ m("div", { className: "flex-column gap-4", children: [
              /* @__PURE__ */ m("div", { className: `grid gap-3 ${R > 0 ? "grid-cols-2" : "grid-cols-1"}`, children: [
                /* @__PURE__ */ m("div", { className: "rounded-xl border border-green-200 bg-semantic-success-container px-4 py-3.5", children: [
                  /* @__PURE__ */ m("div", { className: "flex items-center gap-2 mb-1", children: [
                    /* @__PURE__ */ r("i", { className: "iki iki-check text-semantic-success" }),
                    /* @__PURE__ */ r("div", { className: "text-label-sm font-semibold text-semantic-on-success-container uppercase tracking-wider", children: l.willBeUploaded })
                  ] }),
                  /* @__PURE__ */ r("div", { className: "text-2xl font-bold", children: M.length }),
                  /* @__PURE__ */ r("div", { className: "text-label-sm text-text-weak mt-0.5", children: l.filesLabel })
                ] }),
                R > 0 && /* @__PURE__ */ m("div", { className: "rounded-xl border border-border-weak bg-surface-default px-4 py-3.5", children: [
                  /* @__PURE__ */ m("div", { className: "flex items-center gap-2 mb-1", children: [
                    /* @__PURE__ */ r("i", { className: "iki iki-minus text-text-weakest" }),
                    /* @__PURE__ */ r("div", { className: "text-label-sm font-semibold text-text-weakest uppercase tracking-wider", children: l.skipped })
                  ] }),
                  /* @__PURE__ */ r("div", { className: "text-2xl font-bold", children: R }),
                  /* @__PURE__ */ r("div", { className: "text-label-sm text-text-weak mt-0.5", children: l.alreadyExist })
                ] })
              ] }),
              a && /* @__PURE__ */ m("div", { className: "rounded-xl border border-blue-200 bg-semantic-info-container px-4 py-3.5", children: [
                /* @__PURE__ */ m("div", { className: "flex items-center justify-between mb-2", children: [
                  /* @__PURE__ */ r("span", { className: "text-body-sm font-medium text-blue-700", children: l.uploadingTitle }),
                  /* @__PURE__ */ m("span", { className: "text-body-sm text-semantic-info font-semibold", children: [
                    A,
                    "%"
                  ] })
                ] }),
                /* @__PURE__ */ r("div", { className: "w-full h-1.5 bg-blue-200 rounded-pill overflow-hidden", children: /* @__PURE__ */ r("div", { className: "h-full bg-blue-500 rounded-pill transition-[width] duration-300 ease-in-out", style: { width: `${A}%` } }) }),
                /* @__PURE__ */ r("div", { className: "text-label-sm text-blue-500 mt-1.5", children: l.uploadProgress(
                  M.filter((x) => (z[x.filename] ?? 0) === 100).length,
                  M.length
                ) })
              ] }),
              Object.keys(V).length > 0 && /* @__PURE__ */ m("div", { className: "rounded-xl border border-border-weak bg-surface-default overflow-hidden", children: [
                /* @__PURE__ */ r("div", { className: "px-3.5 py-2.5 bg-surface-dim border-b border-border-weak text-label-sm font-semibold text-text-weakest uppercase tracking-wider", children: l.destinationMap }),
                /* @__PURE__ */ r("div", { className: "py-1 max-h-48 overflow-y-auto", children: Object.entries(V).map(([x, W]) => /* @__PURE__ */ m("div", { className: "px-3.5 py-2", children: [
                  /* @__PURE__ */ m("div", { className: "flex items-center gap-2 font-mono text-body-sm text-text-weak mb-1", children: [
                    /* @__PURE__ */ r("i", { className: "iki iki-folder text-semantic-info" }),
                    /* @__PURE__ */ r("span", { className: "font-medium text-text-default", children: x })
                  ] }),
                  /* @__PURE__ */ r("div", { className: "ml-5 flex-column gap-0.5", children: W.map((b) => /* @__PURE__ */ r("div", { className: "font-mono text-label-sm text-text-weak", children: b.filename }, b.filename)) })
                ] }, x)) })
              ] })
            ] }),
            e === "done" && /* @__PURE__ */ m("div", { className: "py-10 text-center", children: [
              /* @__PURE__ */ r("div", { className: "w-16 h-16 rounded-round bg-semantic-success-container mx-auto mb-4 flex items-center justify-center", children: /* @__PURE__ */ r("i", { className: "iki iki-check text-semantic-success text-[2em]" }) }),
              /* @__PURE__ */ r("div", { className: "text-title-md font-semibold mb-1.5", children: l.allDone }),
              /* @__PURE__ */ r("div", { className: "text-body-sm text-text-weakest mb-5", children: l.doneMessage(M.length) }),
              /* @__PURE__ */ r(
                "button",
                {
                  className: "border border-border-default bg-surface-default rounded-l px-4 py-2 text-body-sm font-medium hover:bg-surface-dim",
                  onClick: o,
                  children: l.close
                }
              )
            ] })
          ] }),
          e !== "done" && /* @__PURE__ */ m("div", { className: "px-5 py-3.5 border-t border-border-weak bg-surface-default flex items-center justify-between gap-3", children: [
            /* @__PURE__ */ r("button", { className: "text-text-weak hover:bg-surface-dim px-3 py-1.5 rounded-l text-body-sm font-medium transition-colors", onClick: o, children: l.cancel }),
            /* @__PURE__ */ m("div", { className: "flex gap-2", children: [
              e === "results" && /* @__PURE__ */ m(
                "button",
                {
                  className: "border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium hover:bg-surface-dim flex items-center gap-1.5",
                  onClick: E,
                  children: [
                    /* @__PURE__ */ r("i", { className: "iki iki-chevron-left" }),
                    " ",
                    l.back
                  ]
                }
              ),
              e === "confirm" && /* @__PURE__ */ m(
                "button",
                {
                  className: `border border-border-default bg-surface-default rounded-l px-3 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${a ? "opacity-disabled cursor-not-allowed" : "hover:bg-surface-dim"}`,
                  onClick: () => !a && J(),
                  children: [
                    /* @__PURE__ */ r("i", { className: "iki iki-chevron-left" }),
                    " ",
                    l.back
                  ]
                }
              ),
              e === "select" && /* @__PURE__ */ m(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${c.length === 0 || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: g,
                  disabled: c.length === 0 || s,
                  children: [
                    s ? l.analyzing : l.analyzeButton,
                    !s && /* @__PURE__ */ r("i", { className: "iki iki-chevron-right" })
                  ]
                }
              ),
              e === "results" && /* @__PURE__ */ m(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${M.length === 0 || s ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: h,
                  disabled: M.length === 0 || s,
                  children: [
                    l.continueButton(M.length),
                    /* @__PURE__ */ r("i", { className: "iki iki-chevron-right" })
                  ]
                }
              ),
              e === "confirm" && /* @__PURE__ */ r(
                "button",
                {
                  className: `bg-semantic-info text-text-white rounded-l px-4 py-1.5 text-body-sm font-medium flex items-center gap-1.5 ${a || M.length === 0 ? "opacity-disabled cursor-not-allowed" : "hover:bg-blue-700"}`,
                  onClick: $,
                  disabled: a || M.length === 0,
                  children: a ? /* @__PURE__ */ m(re, { children: [
                    /* @__PURE__ */ r("span", { className: "w-3 h-3 border-[1.5px] border-text-white border-t-transparent rounded-round inline-block animate-spin" }),
                    l.uploading
                  ] }) : /* @__PURE__ */ r(re, { children: l.uploadButton(M.length) })
                }
              )
            ] })
          ] })
        ] })
      ]
    }
  );
}, _r = ({ input: e, onInputChange: n, onSearch: t, onClose: o, isSearching: i, error: s, results: a, onFileClick: l, strings: c }) => {
  const d = c;
  return /* @__PURE__ */ m("div", { className: "card padded flex-column gap-half max-h-[70vh] overflow-hidden shadow-[0_10px_40px_rgba(0,0,0,0.3)]", children: [
    /* @__PURE__ */ m("div", { className: "relative", children: [
      /* @__PURE__ */ r("i", { className: "iki iki-ai absolute left-3 top-3 text-[1.6em] opacity-50" }),
      /* @__PURE__ */ r(
        "input",
        {
          autoFocus: !0,
          type: "text",
          placeholder: d.placeholder,
          className: "text-[1.5em] p-[10px] h-auto pl-[50px] w-full",
          value: e,
          onChange: (p) => n(p.currentTarget.value)
        }
      )
    ] }),
    /* @__PURE__ */ r("div", { className: "italic opacity-70", children: /* @__PURE__ */ r("span", { children: d.description }) }),
    /* @__PURE__ */ m("div", { className: "flex-row gap-half", children: [
      /* @__PURE__ */ r("button", { onClick: t, disabled: !(e != null && e.trim()) || i, children: i ? d.searchingButton : d.searchButton }),
      /* @__PURE__ */ r("button", { onClick: o, children: d.cancelButton })
    ] }),
    /* @__PURE__ */ m("div", { className: i ? "overlay-loading overflow-y-auto flex-1 min-h-0" : "overflow-y-auto flex-1 min-h-0", children: [
      s && /* @__PURE__ */ r("div", { className: "padded alert alert-danger", children: s }),
      a && /* @__PURE__ */ r("div", { className: "flex-column gap", children: a.matches && a.matches.length > 0 ? /* @__PURE__ */ m(re, { children: [
        a.needs_clarification && /* @__PURE__ */ r("div", { className: "padded alert alert-warning", children: d.needsClarification }),
        /* @__PURE__ */ m("div", { className: "flex-column", children: [
          /* @__PURE__ */ m("header", { className: "py-2 font-bold", children: [
            d.foundFilesLabel,
            " (",
            a.matches.length,
            ")"
          ] }),
          a.matches.map((p) => /* @__PURE__ */ m(
            "div",
            {
              className: "clickable flex p-3 rounded cursor-pointer transition-colors duration-150 hover:bg-black/5",
              onClick: () => l(p),
              children: [
                /* @__PURE__ */ r("div", { className: "w-10 h-10 flex items-center justify-center mr-3 text-[1.5em] opacity-70", children: /* @__PURE__ */ r("i", { className: "iki iki-files" }) }),
                /* @__PURE__ */ m("div", { className: "flex-column gap-[5px]", children: [
                  /* @__PURE__ */ r("div", { className: "flex-row font-medium text-[1.05em]", children: p.file_name }),
                  p.folder_path && /* @__PURE__ */ r("div", { className: "text-[0.9em] opacity-70", children: p.folder_path })
                ] })
              ]
            },
            p.file_uuid
          ))
        ] })
      ] }) : /* @__PURE__ */ r("div", { className: "padded text-center", children: d.noResults }) }),
      !a && !i && !s && /* @__PURE__ */ r("div", { className: "padded text-center text-[1.1em] m-auto opacity-70", children: d.enterQuery })
    ] })
  ] });
};
export {
  Br as AISparkleIcon,
  $r as AiLibrarianPanel,
  _r as AiSearchPanel,
  Vr as BottomNav,
  Jt as Button,
  tr as Card,
  Ut as Input,
  Er as LibrarianResultItem,
  dr as List,
  rr as NavRail,
  nr as SideNav,
  Tr as Tree,
  ve as TreeNodeRow,
  Qt as buttonVariants,
  er as cardVariants,
  O as cn,
  ur as collectAllFolderIds,
  mr as defaultMatchesFilter,
  Zt as inputVariants,
  cr as listVariants
};
